import React from "react";
import {
  FormSectionElements,
  FormSections,
  FormSubSections,
  ProgramContainer,
} from "../entities/formTemplateDataType";
import { Accordion, AccordionTab } from "primereact/accordion";
import { SubSectionComponent } from "../runtimeComponent/SubSectionComponent";
import { SelectButton } from "primereact/selectbutton";
import { User } from "../entities/User";
import { Panel } from "primereact/panel";
import Parser from "html-react-parser";
import { Button } from "primereact/button";
import axios from "axios";
import DataUtils, {
  collectDataForReload,
  removeAttachmentSections,
} from "../utilities/DataUtils";
import { Steps } from "primereact/steps";
import { ConfirmDialog } from "primereact/confirmdialog";
import FormValidationUtils from "../utilities/FormValidationUtils";
import ReactDOMServer from "react-dom/server";
import html2pdf from "html2pdf.js";
import { Toast } from "primereact/toast";
import { MsalContext } from "@azure/msal-react";
import { ErrorAlertsComponent } from "../runtimeComponent/odsCalloutBox/ErrorAlertsComponent";
import StepIndicator from "../runtimeComponent/subComponent/step-indicator/StepIndicator";
import { SpinnerComponent } from "../commonComponent/SpinnerComponent";
import { replaceTitlePlaceholders } from "../commonComponent/TileSelectionComponent";
import { ProgressBar } from "primereact/progressbar";
import { replaceStepNumber } from "../runtimeComponent/subComponent/bxp/StepperUtils";
// import { gaCustomEvent, gaEvent, gaPageview } from "../utilities/GAUtils";
import {
  getQuizGaData,
  sendRatingAndFeedbackToGA,
  sendSummaryInfoToGA,
} from "../services/GADataUtils";
import {
  generateAndDownloadPDF,
  generateBase64PdfTemplate,
} from "../services/PDFGenerationService";
import Utils from "../utilities/Utils";
import {
  focusOnFirstErrorElement,
  getPublicSecurePage,
  getSectionFilterValueMap,
} from "../utilities/ElementUtils";
import SectionUtils from "../utilities/SectionUtils";
import { formatField } from "../utilities/PatternFormatterUtils";
import { generateReviewHtml } from "../utilities/ReviewHtmlUtils";
import { ElementComponent } from "../runtimeComponent/ElementComponent";
import HelmetComponent from "../commonComponent/HelmetComponent";
import { CMAFormComponent } from "./CMAFormComponent";
import SessionStorageService from "../services/SessionStorageService";
import URLUtils, {
  getSectionIndexFromPathname,
  isLocalhost,
  normalizeCxpRedirectPath,
  pushSectionUrlToHistory,
} from "../utilities/URLUtils";
import { AUTH_TOKENS, TOKEN_TYPE } from "../entities/Constants";
import {
  KNOWN_BLOCK_IDS,
  NO_CERT_ROLES,
  VISIBLE_FOR_ROLE,
} from "../entities/RegulatedPersonnelConstants";
import { faker } from "@faker-js/faker";
import { apiUrl, isRuntime } from "../config";
import CustomButton from "../runtimeComponent/subComponent/step-indicator/button";
import { DetailFormComponent } from "./DetailFormComponent";
import TimeoutComponent from "../TimeoutComponent";
import {
  cleanSession,
  signin,
  getAndValidateAdvanceFlag,
  consumeAdvanceFlag,
} from "../security/PublicSecure";
import { SessionEndComponent } from "../SessionEndComponent";
import PDFViewerPrintComponent from "../commonComponent/PDFViewerPrintComponent";
import Card from "../runtimeComponent/card";
import LoginBannerComponent from "../runtimeComponent/subComponent/LoginBannerComponent";
import DuplicateSubSectionSummary from "../runtimeComponent/summary/DuplicateSubSectionSummary";
import FeedbackBannerComponent from "../runtimeComponent/subComponent/FeedbackBannerComponent";
import { se } from "date-fns/locale";
import { ButtonComponent as RuntimeButtonComponent } from "../runtimeComponent/subComponent/ButtonComponent";
import { getEnvVar, SCRIPT_ENV } from "../config/RuntimeConfig";

interface Props {
  programContainer: ProgramContainer;
  isEng: boolean;
  user?: User;
  hash?;
  stepperIndex?: number;
  onStepChange?: (stepperIndex: number) => void;
  callback: (programContainer: ProgramContainer) => void;
  callbackOriginalData;
  callBackLang: (isEng: boolean) => void;
  isProfileLoaded?: boolean;
}

interface State {
  confirmationVisible: boolean;
  summaryVisible: boolean;
  activeIndex;
  stepperIndex: number;
  isBusy: boolean;
  showConfirmationDialog: boolean;
  showReview: boolean;
  showForm: boolean;
  reviewButtonVisible: boolean;
  validationErrMsg: any;
  isComplete: boolean;
  showModal: boolean;
  showSessionEndPage: boolean;
  showPrintDialog: boolean; // Add this line
  pdfFileUrl: string;
  fromAPI?: boolean;
  transactionId: string;
  submissionError: boolean;
  showDownloadSummary: boolean;
  applicationType: string;
  renewType?: string;
  isBXPSubmit: boolean;
  isDirtyForm: boolean;
  showTopButton: boolean;
  sectionDataLoaded: boolean;
  navigatedFromSummary: boolean;
}

export class FormPreviewComponent extends React.Component<Props, State> {
  idleTimeout;
  idleDuration: number;
  events = ["mousemove", "keydown", "mousedown", "touchstart"];
  HtmlToReactParser = require("html-to-react").Parser;
  caseId;
  language: any;
  sectionArray: [];
  removingIndex;
  // validationErrMsg: any = [];
  sortedList: FormSections[];

  recaptcha: any;
  growl: Toast;
  continueButtonHidden;
  // NotStep:boolean;
  static contextType = MsalContext;
  gaTrackingId = this.props.programContainer?.GATrackingID;
  activeStepList: Set<number>;
  returnIndex: number;
  errorRef: React.RefObject<HTMLDivElement>;
  headingRef: React.RefObject<HTMLHeadingElement>;
  // To keep track the index of the current page.
  currentPageIndex = -1;
  private preScriptedStepIndex?: number;
  private eventListenersAdded = false;
  isBXP =
    this.props.programContainer.CategoryId?.toUpperCase().startsWith("BXP");
  private addTimestampFooter = (pdf: any) => {
    const width = pdf.internal.pageSize.getWidth();
    const height = pdf.internal.pageSize.getHeight();
    const totalPages = pdf.internal.getNumberOfPages();
    const timestamp = new Date().toLocaleString();
    const copyright = "© King's Printer for Ontario, 26";

    for (let i = 1; i <= totalPages; i++) {
      pdf.setPage(i);
      pdf.setFontSize(10);
      pdf.text(copyright, 10, height - 10, { align: "left" });
      pdf.text(timestamp, width - 10, height - 10, { align: "right" });
    }
  };

  constructor(props: Props) {
    super(props);
    this.errorRef = React.createRef();
    this.headingRef = React.createRef<HTMLHeadingElement>();
    this.sortFormList();
    const sectionCount =
      this.sortedList?.length ??
      this.props.programContainer?.ListOfFormSections?.length ??
      0;
    const collapseHeadersByDefault = sectionCount > 1;
    const initialAccordionIndex: any = collapseHeadersByDefault ? [] : 0;
    let initialStepperIndex = this.props.stepperIndex || 0;
    if (getEnvVar("IS_RUNTIME") === "false") {
      const sessionIndex = sessionStorage.getItem("stepperIndex");
      const parsedIndex =
        sessionIndex != null ? parseInt(sessionIndex, 10) : NaN;
      if (Number.isFinite(parsedIndex)) {
        initialStepperIndex = parsedIndex;
      }
    }
    initialStepperIndex = this.getSafeStepperIndex(initialStepperIndex);

    this.state = {
      confirmationVisible: false,
      summaryVisible: true,
      showConfirmationDialog: false,
      activeIndex: initialAccordionIndex,
      stepperIndex: initialStepperIndex,
      isBusy: false,
      showForm: true,
      showReview: false,
      sectionDataLoaded: false,
      reviewButtonVisible: false,
      validationErrMsg: [],
      isComplete: false,
      showModal: false,
      showSessionEndPage: false,
      showPrintDialog: false, // Add this line
      pdfFileUrl: "",
      transactionId: "",
      submissionError: false,
      showDownloadSummary: true,
      applicationType: "",
      renewType: "",
      isBXPSubmit: false,
      isDirtyForm: false,
      showTopButton: false,
      navigatedFromSummary: false,
    };
    this.props.programContainer.resumeStepperIndex = this.state.stepperIndex;

    this.idleTimeout = null;
    this.idleDuration = Number(getEnvVar("SESSION_DURATION")) * 60 * 1000;

    if (getEnvVar("IS_RUNTIME") === "false") {
      this.activeStepList = sessionStorage.getItem("activeStepList")
        ? new Set(JSON.parse(sessionStorage.getItem("activeStepList")))
        : new Set<number>();
    } else {
      this.activeStepList = new Set<number>();
    }

    //   this.activeStepList.add(0); //add the first page
    this.handleBXPSummaryCallback = this.handleBXPSummaryCallback.bind(this);

    if (this.props.stepperIndex) {
      this.populateActiveStepList(this.sortedList);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("popstate", this.handlePopState);
    if (this.idleTimeout) clearTimeout(this.idleTimeout);
    if (this.eventListenersAdded) {
      this.events.forEach((event) =>
        window.removeEventListener(event, this.handleEvent),
      );
      this.eventListenersAdded = false;
    }
    window.removeEventListener("scroll", this.updateTopButtonVisibility);
    window.removeEventListener("resize", this.updateTopButtonVisibility);
    // Clean up the advance flag on unmount to prevent stale data
    localStorage.removeItem("advanceAfterCxpReturn");
  }
  getCurrentBXPStepIndex = (): number | undefined => {
    const currentStepIndex = (window as any).currentBXPStepIndex;
    return typeof currentStepIndex === "number" ? currentStepIndex : undefined;
  };

  handlePopState = (event) => {
    console.log("Back/forward pressed:", event.state);
    let stepperIndex = event.state?.sectionIndex;

    // Validate section when browser forward button is clicked.
    if (
      this.props.programContainer.ValidateSectionWhenBrowerForwardClicked &&
      this.browserForwardClicked(this.currentPageIndex, stepperIndex)
    ) {
      const section =
        this.props.programContainer.ListOfFormSections[this.currentPageIndex];
      const invalidControls = FormValidationUtils.invalidControls(section);

      if (invalidControls?.length > 0) {
        invalidControls.forEach((field) => {
          field.Touched = true;
        });
        this.setState({ validationErrMsg: invalidControls });
        window.scrollTo({ top: 0, behavior: "smooth" });
        history.back(); // Should not show the URL of the next page.
        return;
      }
    }

    if (event.state && event.state.__app) {
      this.currentPageIndex = stepperIndex;
      this.setStatus(stepperIndex);
    } else {
      stepperIndex = getSectionIndexFromPathname(
        this.props.programContainer,
        window.location.pathname,
      );
      if (stepperIndex > -1) {
        this.currentPageIndex = stepperIndex;
        this.setStatus(stepperIndex);
      } else {
        history.back();
      }
    }
  };

  browserForwardClicked = (
    currPageIndex: number,
    nextPageIndex: number,
  ): boolean => {
    if (!nextPageIndex || nextPageIndex < 0) {
      nextPageIndex = getSectionIndexFromPathname(
        this.props.programContainer,
        window.location.pathname,
      );
    }
    return nextPageIndex ? nextPageIndex > currPageIndex : false;
  };

  setStatus = (stepperIndex) => {
    const section =
      this.props.programContainer.ListOfFormSections[stepperIndex];

    // Determine if we're navigating FROM a summary page to an editable page
    // Use showReview/showForm state instead of stepperIndex because
    // handleContinueClick sets showReview=true without updating stepperIndex
    const comingFromSummary = this.state.showReview && !this.state.showForm;

    if (stepperIndex > -1) {
      if (section?.CustomizedReviewPage) {
        this.setState(
          {
            stepperIndex: stepperIndex,
            showForm: false,
            showReview: true,
            navigatedFromSummary: false,
          },
          () => {
            window.scrollTo({ top: 0, behavior: "smooth" });
          },
        );
      } else {
        this.setState(
          {
            stepperIndex: stepperIndex,
            showForm: true,
            showReview: false,
            navigatedFromSummary:
              comingFromSummary || this.state.navigatedFromSummary,
          },
          () => {
            window.scrollTo({ top: 0, behavior: "smooth" });
          },
        );
      }
    }
  };

  resetTimer = () => {
    if (this.idleTimeout) clearTimeout(this.idleTimeout);
    if (this.state.showModal) {
      this.setState({ showModal: false });
    }
    this.idleTimeout = setTimeout(
      () => this.setState({ showModal: true }),
      this.idleDuration,
    );
  };

  handleEvent = () => {
    this.resetTimer();
  };

  handleClose = () => {
    this.setState({ showModal: false });
    this.resetTimer();
  };

  modalTimeout = () => {
    const timeoutRedirectURL = this.props.isEng
      ? this.props.programContainer.TimeoutRedirectURL
      : this.props.programContainer.TimeoutRedirectURLFRA;

    SectionUtils.resetDirtyFlags(this.props.programContainer);
    this.setState({ showModal: false, showSessionEndPage: true });
    cleanSession(
      this.props.programContainer.CategoryId,
      this.props.programContainer.Profile,
      this.props.isEng ? "en" : "fr",
      timeoutRedirectURL,
    );
  };

  handleCancel = () => {
    const timeoutRedirectURL = this.props.isEng
      ? this.props.programContainer.TimeoutRedirectURL
      : this.props.programContainer.TimeoutRedirectURLFRA;

    SectionUtils.resetDirtyFlags(this.props.programContainer);
    cleanSession(
      this.props.programContainer.CategoryId,
      this.props.programContainer.Profile,
      this.props.isEng ? "en" : "fr",
      timeoutRedirectURL,
    );
  };

  componentDidUpdate(
    prevProps: Readonly<Props>,
    prevState: Readonly<State>,
    snapshot?: any,
  ): void {
    if (
      prevProps.stepperIndex !== this.props.stepperIndex &&
      this.props.stepperIndex != null
    ) {
      if (this.props.stepperIndex !== this.state.stepperIndex) {
        this.setState({ stepperIndex: this.props.stepperIndex });
        return;
      }
    }
    this.sortFormList();
    if (this.ensureStepperIndexIsValid()) {
      return;
    }
    if (this.state.showModal) {
      if (this.eventListenersAdded) {
        this.events.forEach((event) =>
          window.removeEventListener(event, this.handleEvent),
        );
        this.eventListenersAdded = false;
      }
      if (this.idleTimeout) clearTimeout(this.idleTimeout);
    }

    if (this.state.stepperIndex !== prevState.stepperIndex) {
      this.props.programContainer.resumeStepperIndex = this.state.stepperIndex;
      this.headingRef.current?.focus();
      this.props.onStepChange?.(this.state.stepperIndex);

      const currentSection = this.sortedList?.[this.state.stepperIndex];
      if (
        currentSection &&
        this.preScriptedStepIndex !== this.state.stepperIndex
      ) {
        this.execuetPreScript(currentSection);
        this.props.callback(this.props.programContainer);
      }
      this.preScriptedStepIndex = this.state.stepperIndex;
    }

    // After Public Secure sign-in, the first section (e.g., an Instructions page)
    // can be hidden while stepperIndex stays at 0. In runtime mode this causes
    // the URL to still reflect the old page (e.g., /instructions) even though
    // the next visible section (e.g., Terms of use) is shown. If we detect
    // that state.stepperIndex is 0 but the first section is not visible,
    // automatically jump to the first visible section after it and update the URL.
    if (
      (isRuntime() === "true" || isRuntime() === "deployed") &&
      this.props.programContainer?.ListOfFormSections?.length &&
      this.state.stepperIndex === 0
    ) {
      const sections = this.props.programContainer.ListOfFormSections;
      const firstSection = sections[0];

      if (firstSection && firstSection.Visible === false) {
        const nextIndex = sections.findIndex(
          (section, index) => index > 0 && section.Visible,
        );
        if (nextIndex > 0 && nextIndex !== this.state.stepperIndex) {
          this.setState({ stepperIndex: nextIndex }, () => {
            this.addUrlToHistory(nextIndex);
          });
        }
      }
    }

    // If we have returned from Public Secure (code param or tokens present),
    // jump straight to the Public Secure section to avoid rerunning earlier sections.
    if (
      (isRuntime() === "true" || isRuntime() === "deployed") &&
      this.props.programContainer?.AuthRequired?.toLowerCase?.() === "ps"
    ) {
      const sections =
        this.sortedList ?? this.props.programContainer?.ListOfFormSections;
      const publicSecureSection = sections
        ? getPublicSecurePage(sections)
        : undefined;
      if (publicSecureSection && sections) {
        const publicSecureIndex = sections.indexOf(publicSecureSection);
        const returnedFromAuth =
          new URLSearchParams(window.location.search).has("code") ||
          !!sessionStorage.getItem(AUTH_TOKENS);

        if (
          returnedFromAuth &&
          publicSecureIndex > -1 &&
          this.state.stepperIndex < publicSecureIndex
        ) {
          this.execuetPreScript(publicSecureSection);
          this.preScriptedStepIndex = publicSecureIndex;
          this.setState({ stepperIndex: publicSecureIndex }, () => {
            this.addUrlToHistory(publicSecureIndex);
          });
          return;
        }

        // Check if we should advance past the public secure section after CXP account creation
        // This runs separately to handle cases where stepperIndex is already at publicSecureIndex
        // Using localStorage because it persists across domain navigations (unlike sessionStorage)
        const shouldAdvance = getAndValidateAdvanceFlag();
        if (shouldAdvance && returnedFromAuth && publicSecureIndex > -1) {
          // Flag is automatically cleaned up by getAndValidateAdvanceFlag

          // Find the next visible section after public secure
          let targetIndex = publicSecureIndex + 1;

          // Make sure the next index is valid and find the first visible section
          while (
            targetIndex < sections.length &&
            sections[targetIndex]?.Visible === false
          ) {
            targetIndex++;
          }

          // Only advance if we found a valid visible section and we're not already past it
          if (
            targetIndex < sections.length &&
            this.state.stepperIndex <= publicSecureIndex
          ) {
            console.log(
              `Advancing from section ${publicSecureIndex} to ${targetIndex} after CXP account creation`,
            );

            // Consume the flag now that we're using it
            consumeAdvanceFlag();

            this.setState({ stepperIndex: targetIndex }, () => {
              this.addUrlToHistory(targetIndex);
            });
            return;
          } else {
            console.log(
              `Not advancing: targetIndex=${targetIndex}, sections.length=${sections.length}, current stepperIndex=${this.state.stepperIndex}`,
            );
          }
        }
      }
    }

    this.enforcePublicSecureAuthTokens();

    // this.loadSectionInitialData(this.sortedList[this.currentPageIndex]);
  }

  private enforcePublicSecureAuthTokens = () => {
    const authRequired = this.props.programContainer?.AuthRequired;
    if (
      typeof authRequired !== "string" ||
      authRequired.toLowerCase() !== "ps"
    ) {
      return;
    }

    const sections =
      this.sortedList ?? this.props.programContainer?.ListOfFormSections;
    if (!sections || !sections.length) {
      return;
    }

    const publicSecureSection = getPublicSecurePage(sections);
    if (!publicSecureSection) {
      return;
    }

    const publicSecureIndex = sections.indexOf(publicSecureSection);
    if (publicSecureIndex < 0) {
      return;
    }

    const currentIndex = this.state.stepperIndex ?? 0;
    if (currentIndex <= publicSecureIndex) {
      return;
    }

    if (!sessionStorage.getItem(AUTH_TOKENS)) {
      signin(this.props.programContainer.CategoryId, this.props.isEng);
    }
  };

  /**
   * To populate the activeStepList as if it has gone thru the flow until the stepperIndex from props.
   * @param pages
   */
  populateActiveStepList(pages: FormSections[]) {
    if (pages?.length) {
      pages
        .filter((page) => {
          return (
            (page.Sequence == 1 && !page.IsFrontPage && !page.NotStep) ||
            (page.Sequence > 1 &&
              page.Sequence <= this.props.stepperIndex + 1 &&
              page.Visible)
          );
        })
        .map((visiblePage) => {
          this.activeStepList.add(visiblePage.Sequence - 1);
        });
    }
  }

  sortFormList = () => {
    if (this.props.programContainer != null) {
      this.sortedList = this.props.programContainer.ListOfFormSections?.sort(
        (a, b) => a.Sequence - b.Sequence,
      );
      this.sortedList?.forEach(async (section) => {
        // if (section.PreScript) {
        //     try {
        //         const customJSFunc = eval(`(${section.PreScript})`);
        //         // customJSFunc(section, process.env);
        //     } catch (ex) {
        //         console.log(ex);
        //     }
        // }
        section.findFieldByName = (fieldName) => {
          const root = section.parent;

          const formList = root.ListOfFormSections as FormSections[];
          let eleReturned;
          try {
            formList.forEach((section) => {
              if (section.Visible == false) return;
              section.ListOfFormSubSections.forEach((sub) => {
                const elements = sub.ListOfFormSectionElements;
                elements.forEach((ele) => {
                  if (ele.LoadBindName == fieldName) {
                    eleReturned = ele;
                    throw new Error("Exit all loops");
                  }
                });
              });
            });
          } catch {
            return eleReturned;
          }
          return null;
        };
        section.findSectionByTitle = (sectionTitle) => {
          const root = section.parent;

          const formList = root.ListOfFormSections as FormSections[];
          if (formList != null && formList.length > 0) {
            for (var sec of formList) {
              if (sec.ENUTitle == sectionTitle) {
                return sec;
              }
            }
          }

          return null;
        };

        section.findSubsectionByTitle = (subsectionTitle) => {
          return section.ListOfFormSubSections.find(
            (subsection) => subsection.ENUTitle == subsectionTitle,
          );
        };
        section.formatField = formatField;
      });
    }
  };

  private cleanupStaleAdvanceFlag = (): void => {
    // Check if the flag exists and is expired, then remove it
    try {
      const stored = localStorage.getItem("advanceAfterCxpReturn");
      if (!stored) {
        return;
      }

      const flagData = JSON.parse(stored);
      if (flagData && flagData.timestamp && flagData.expiresIn) {
        const now = Date.now();
        const expirationTime = flagData.timestamp + flagData.expiresIn;

        if (now >= expirationTime) {
          localStorage.removeItem("advanceAfterCxpReturn");
          console.log(
            "Expired advanceAfterCxpReturn flag removed on mount (preview)",
          );
        }
      }
    } catch {
      // Ignore errors
    }
  };

  componentDidMount = () => {
    // Clean up any stale advanceAfterCxpReturn flags on mount
    this.cleanupStaleAdvanceFlag();

    if (this.headingRef.current) {
      this.headingRef.current.focus();
    }

    if (
      (isRuntime() === "true" || isRuntime() === "deployed") &&
      this.props.programContainer.TimeoutPopup
    ) {
      this.resetTimer();
      if (!this.eventListenersAdded) {
        this.events.forEach((event) =>
          window.addEventListener(event, this.handleEvent),
        );
        this.eventListenersAdded = true;
      }
    }
    if (this.props.programContainer != null) {
      this.sortFormList();
      if (isRuntime() === "true" || isRuntime() == "deployed") {
        this.getCase();
      } else {
        DataUtils.initDuplicateSections(this.props.programContainer);
      }
    }

    if (!this.props.stepperIndex && this.sortedList?.length > 0) {
      let firstForm = this.sortedList[0];
      if (!(firstForm.IsFrontPage || firstForm.NotStep)) {
        this.activeStepList.add(0);
      }
    }

    this.ensureStepperIndexIsValid();

    this.enforcePublicSecureAuthTokens();

    // attach once when component is mounted
    window.addEventListener("popstate", this.handlePopState);
    window.addEventListener("scroll", this.updateTopButtonVisibility);
    window.addEventListener("resize", this.updateTopButtonVisibility);
    this.updateTopButtonVisibility();
  };

  getCase = async () => {
    let api = this.props.programContainer.GetAPI;
    let apiBase = this.props.programContainer.APIBasePath;
    let getUrl = apiBase + "/" + api;
    let response = null;
    //java api transfers to destination
    if (this.props.programContainer.AuthRequired != "tk") {
      let url = window.location.href;
      url = url.replace("/fr", "");
      let pathSegmentsAll = url.split("#");
      if (pathSegmentsAll.length <= 1) {
        pathSegmentsAll = url.split("on-form");
      }

      if (pathSegmentsAll.length > 1) {
        const pathSegments = pathSegmentsAll[1]
          .split("/")
          .filter((p) => p != "");

        const segNumber = pathSegments.length;

        if (api == null || api == "") {
          return;
        }

        const regex = /{[^{}]*}/g;
        const matches = api.match(regex);
        if (matches) {
          let param1;
          let param2;

          switch (segNumber) {
            case 1:
              break;
            case 2:
              param1 = pathSegments[segNumber - 1];
              getUrl = getUrl.replace(matches[0], param1);
              getUrl = getUrl.replace(matches[1], "");
              this.props.programContainer[
                matches[0].replace("{", "").replace("}", "")
              ] = param1;
              break;
            case 3:
              param1 = pathSegments[segNumber - 2];
              param2 = pathSegments[segNumber - 1];
              getUrl = getUrl
                .replace(matches[0], param1)
                .replace(matches[1], param2);

              this.props.programContainer[
                matches[0].replace("{", "").replace("}", "")
              ] = param1;
              this.props.programContainer[
                matches[1].replace("{", "").replace("}", "")
              ] = param2;
              break;
          }
        }
      }

      if (this.props.programContainer.UseProxy == "Y") {
        console.log("load data");
        let transferPayload = {
          url: getUrl,
          httpMethod: "GET",
          payload: "",
        };
        const headers = {
          "Content-Type": "application/json",
          ApplicationId: this.props.programContainer.CategoryId,
        };

        response = await axios.post(apiUrl() + "/transfer", transferPayload, {
          headers: headers,
        });
      } else {
        if (this.props.programContainer.AuthRequired === "ad") {
          // const msalInstance = this.context["instance"];
          // const msalAccounts = this.context["accounts"];
          // const msalInProgress = this.context["inProgress"];
          // const responseToken = await msalInstance.acquireTokenSilent({
          //     scopes: [`api://${process.env.clientId}/Files.Read`],
          //     account: msalAccounts[0],
          // });
          const accessToken = SessionStorageService.getAccessToken(
            TOKEN_TYPE.API,
          );
          response = await axios.get(getUrl, {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          });
        }
      }
    } else {
      const params = new URLSearchParams(window.location.search);
      const key = params.get("key");
      const itemId = params.get("itemId");
      if (key) {
        const current = new URL(window.location.href);
        const env = new URL(getEnvVar("BXP_UI_BASE_PATH"));
        const isSameOrigin = current.origin === env.origin;
        let dataBxp = {};
        const bxpFormData = sessionStorage.getItem("bxpFormData");
        if (!isSameOrigin && (!bxpFormData || !JSON.parse(bxpFormData)[key])) {
          const resp = await fetch(
            `${getEnvVar("BXP_UI_BASE_PATH")}/api/stash-payload?key=${key}`,
            {
              method: "GET",
              headers: { "Content-Type": "application/json" },
            },
          );
          const data = await resp.json();
          dataBxp = JSON.parse(JSON.parse(data.data)[key] ?? data.data);
          sessionStorage.setItem("bxpFormData", data.data);
        } else {
          const sessionData = sessionStorage.getItem("bxpFormData");
          console.log("sessionData: ", sessionData);
          dataBxp = sessionData
            ? JSON.parse(JSON.parse(sessionData)[key] ?? sessionData)
            : {};
          //sessionStorage.removeItem("bxpFormData");
        }
        let dataJson = removeAttachmentSections(dataBxp);
        response = itemId
          ? { itemId: itemId, data: dataJson }
          : { data: dataJson };
        this.props.programContainer.itemId = response.itemId;
      }
      console.log("response Dataaa: ", response);
    }

    if (response && response.data) {
      const data = response.data;
      this.props.programContainer.Entity = response.data;
      if (this.props.programContainer.itemId) {
        DataUtils.restructureForDupSection(this.props.programContainer);
      } else {
        DataUtils.initDuplicateSections(this.props.programContainer);
      }
      DataUtils.assignFormValue(this.props.programContainer);
      this.props.programContainer.IsComplete =
        data.IsComplete == true || data.IsComplete == "Y";
      this.props.callback(this.props.programContainer);
      this.props.callbackOriginalData(data);
      this.setState({ isComplete: data.IsComplete });
      if (
        data != null &&
        data.IsComplete != null &&
        (data.IsComplete == true || data.IsComplete == "Y")
      ) {
        DataUtils.makeCompoenentReadonly(this.props.programContainer);
      }
    } else {
      DataUtils.initDuplicateSections(this.props.programContainer);
    }
  };

  previewForm = () => {
    let panelContents = [];
    let tabPanelContents = [];
    const options = ["English", "French"];
    if (this.props.programContainer == null) return null;
    this.sortFormList();

    if (
      this.props.programContainer.Instructions &&
      this.props.programContainer.Instructions.trim() != "" &&
      this.props.programContainer.Instructions.trim() != "<p><br></p>"
    ) {
      tabPanelContents.push(
        <>
          <AccordionTab key="panel_instructions" header="Instructions">
            <div>
              {this.props.programContainer != null &&
              this.props.programContainer.Instructions != null
                ? Parser(this.props.programContainer.Instructions)
                : null}
            </div>
          </AccordionTab>
        </>,
      );
    }

    if (this.sortedList) {
      for (let formSection of this.sortedList) {
        let panelCaption: string = this.props.isEng
          ? formSection.ENUTitle
          : formSection.FRATitle;
        let addtionalComments: string = this.props.isEng
          ? formSection.ENUDescription
          : formSection.FRADescription;
        let optionsFieldValue = new Map<string, string>();
        formSection.ListOfFormSubSections.forEach((formSubSection) => {
          this.sectionOptionsFieldValue(formSubSection, optionsFieldValue);
        });
        if (formSection.ListOfFormSubSections.length == 1) {
          let subSection = formSection.ListOfFormSubSections[0];

          tabPanelContents.push(
            <>
              {/* @ts-ignore */}
              <AccordionTab
                key={"AccordionTab_panel_" + subSection.ENUTitle}
                header={panelCaption}
              >
                <p
                  style={{
                    display: formSection.ENUDescription ? "block" : "none",
                  }}
                >
                  {addtionalComments}
                </p>
                {/* {this.props.programContainer.OntarioChat ?
                                <OntarioChatComponent currentSection={formSection} lang={this.props.isEng ? 'en' : 'fr'}/> : null
                            } */}
                <SubSectionComponent
                  key={"sub_" + formSection.Id + subSection.Id}
                  isEng={this.props.isEng}
                  {...this.props}
                  // renderHeader={this.props.programContainer.displayForm !== 'NoIndicatorStepper'}
                  activeSubSection={subSection}
                  optionsFieldValue={optionsFieldValue}
                  user={this.props.user}
                  editable={true}
                  topEntity={formSection.Value}
                  roleBasedEditable={true}
                  roleBased={false}
                  ownerEditableOnly={false}
                  callbackGeneratePdf={() => this.downloadPdfInHorizontal()}
                  callbackValidate={(errors) => {
                    this.setState({ validationErrMsg: errors }, () => {
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    });
                  }}
                  callbackStepIndex={(stepperIndex, returnIndex) => {
                    // this.sortedList=this.props.programContainer.ListOfFormSections;
                    this.returnIndex = returnIndex;
                    let section;
                    if (typeof stepperIndex == "number") {
                      section = this.sortedList[stepperIndex];
                    } else {
                      section = stepperIndex;
                    }

                    if (
                      !section.IsInfoPage &&
                      !section.IsTechErrorPage &&
                      !section.IsConfirmationPage
                    )
                      this.activeStepList.add(stepperIndex);
                    this.setState({ stepperIndex: stepperIndex });
                    this.addUrlToHistory(stepperIndex);
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                  onBusyChange={(isBusy) => {
                    this.setState({ isBusy: isBusy });
                  }}
                  callback={(programContainer) => {
                    this.props.callback(programContainer);
                    // this.callBackFromDetailForm(subSection);
                  }}
                />
                {/* {this.addButton(formSection, subSection, 1)} */}
              </AccordionTab>
            </>,
          );
        } else {
          let multiplePanel = [];
          multiplePanel.push(
            <>
              <p
                style={{
                  display: formSection.ENUDescription ? "block" : "none",
                }}
              >
                {addtionalComments}
              </p>
              {/* {this.props.programContainer.OntarioChat && (
                            <OntarioChatComponent currentSection={formSection} lang={this.props.isEng ? 'en' : 'fr'}/>
                        )} */}
            </>,
          );

          formSection.ListOfFormSubSections.sort(
            (a, b) => a.Sequence - b.Sequence,
          ).forEach((subSection, subIndex) => {
            let panelCaption: string = this.props.isEng
              ? subSection.ENUTitle
              : subSection.FRATitle;
            if (panelCaption == null) {
              panelCaption = formSection.ENUTitle + " " + subSection.Sequence;
            }
            multiplePanel.push(
              <div>
                {/* @ts-ignore */}
                <Panel
                  key={"multiplePanel_panel_" + subSection.ENUTitle}
                  header={panelCaption}
                  toggleable
                  style={{ marginBottom: "10px" }}
                >
                  <SubSectionComponent
                    key={"sub_" + subSection.Id}
                    isEng={this.props.isEng}
                    {...this.props}
                    activeSubSection={subSection}
                    optionsFieldValue={optionsFieldValue}
                    renderHeader={
                      this.props.programContainer.displayForm !==
                      "NoIndicatorStepper"
                    }
                    user={this.props.user}
                    editable={true}
                    topEntity={{}}
                    roleBasedEditable={true}
                    roleBased={false}
                    callbackGeneratePdf={() => this.downloadPdfInHorizontal()}
                    callbackValidate={(errors) => {
                      this.setState({ validationErrMsg: errors }, () => {
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      });
                    }}
                    callbackStepIndex={(stepperIndex, returnIndex) => {
                      // this.sortedList=this.props.programContainer.ListOfFormSections;
                      console.log("stepperIndex", stepperIndex);
                      this.returnIndex = returnIndex;
                      const section = this.sortedList[stepperIndex];
                      if (
                        !section.IsInfoPage &&
                        !section.IsTechErrorPage &&
                        !section.IsConfirmationPage
                      )
                        this.activeStepList.add(stepperIndex);
                      this.setState({ stepperIndex: stepperIndex });
                      this.addUrlToHistory(stepperIndex);
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    ownerEditableOnly={false}
                    callback={(programContainer) => {
                      this.props.callback(programContainer);
                      // this.callBackFromDetailForm(subSection);
                    }}
                  />
                </Panel>
                {/* {this.addButton(formSection, subSection, subIndex + 1)} */}
              </div>,
            );
          });
          tabPanelContents.push(
            <>
              <AccordionTab
                key={"AccordionTab_panel_" + formSection.ENUTitle}
                header={panelCaption}
              >
                {multiplePanel}
              </AccordionTab>
            </>,
          );
        }
      }
    }

    panelContents.push(
      <div style={{ width: "100%" }}>
        <HelmetComponent
          title={
            this.props.programContainer?.AppTitle?.[
              this.props.isEng ? "en" : "fr"
            ] || document.title
          }
        />
        <div
          style={{
            display:
              isRuntime() != "false" || this.props.programContainer.EnglishOnly
                ? "none"
                : "flex",
            justifyContent: "end",
            marginBottom: "20px",
          }}
        >
          {/* @ts-ignore */}
          <SelectButton
            value={this.props.isEng ? "English" : "French"}
            onChange={(e) => this.props.callBackLang(e.value == "English")}
            options={options}
          />
        </div>
        {/* <div className='form-header' key="ENUTitle" >
                    {this.props.isEng ? this.props.formSection.ENUTitle : this.props.formSection.FRATitle}
                </div> */}

        <div
          style={{ display: "flex", marginBottom: "20px", marginTop: "10px" }}
        >
          {/* @ts-ignore */}
          <Button
            label="Expand"
            className="p-button-text"
            onClick={() => {
              let list = this.props.programContainer.ListOfFormSections;
              let activeIndex = [];
              for (var i = 0; i <= list.length; i++) {
                activeIndex[i] = i;
              }
              this.setState({ activeIndex: activeIndex });
            }}
          />
          {/* @ts-ignore */}
          <Button
            label="Collapse"
            className="p-button-outlined p-button-secondary"
            style={{
              marginLeft: "5px",
              border: "1px solid grey",
              color: "grey",
            }}
            onClick={() => {
              let activeIndex = this.state.activeIndex;
              activeIndex = []; // Set all elements to false (expanded)
              this.setState({ activeIndex: activeIndex });
            }}
          />
        </div>

        <div>
          {/* @ts-ignore */}
          <Accordion
            multiple
            key="accordion"
            style={{ width: "100%", height: "100%", justifyContent: "center" }}
            activeIndex={this.state.activeIndex}
            onTabChange={(e) => {
              this.setState({ activeIndex: e.index });
              console.log(this.state.activeIndex);
            }}
            onTabOpen={(e) => {
              window.scrollTo(e.originalEvent.clientX, e.originalEvent.clientY);
            }}
          >
            {tabPanelContents}
          </Accordion>
        </div>
        <div>
          <SpinnerComponent isBusy={this.state.isBusy} />
        </div>
      </div>,
    );

    return panelContents;
  };

  addUrlToHistory = (activeIndex: number) => {
    if (!activeIndex) {
      activeIndex = 0;
    }
    this.currentPageIndex = activeIndex;

    if (
      getEnvVar("IS_RUNTIME") == "true" ||
      getEnvVar("IS_RUNTIME") == "withLayout"
    ) {
      const section = this.sortedList?.[activeIndex];
      if (!section) return;

      pushSectionUrlToHistory(
        this.props.programContainer,
        section,
        activeIndex,
        getEnvVar("IS_RUNTIME"),
      );
    } else if (getEnvVar("IS_RUNTIME") == "false") {
      sessionStorage.setItem("stepperIndex", activeIndex?.toString());
      sessionStorage.setItem(
        "activeStepList",
        JSON.stringify(Array.from(this.activeStepList)),
      );
    }
  };

  getActualIndexInVisibleSectionList = () => {
    const sectionIndex = this.state.stepperIndex;
    const section = this.sortFormList[sectionIndex];
    const visibleSectionList = this.sortedList.filter(
      (p) => p.Visible && !p.IsFrontPage && !p.IsTechErrorPage && !p.NotStep,
    );
    const visibleIndex = visibleSectionList.findIndex(
      (p) => p.Id === section?.Id,
    );
    return visibleIndex;
  };

  stepperHeaderGeneration = () => {
    let items; // = this.hideSection();
    let StepperHeader = [];
    const options = ["English", "French"];

    const currentSection = this.sortedList[this.state.stepperIndex];
    SectionUtils.replaceStep(
      currentSection,
      currentSection.orginalClone ?? currentSection,
    );
    const displayErrorCompoenent =
      this.state.validationErrMsg.filter((p) => p.Visible).length > 0;

    switch (this.props.programContainer.displayForm) {
      case "stepper":
        StepperHeader.push(
          <div style={{ width: "100%" }}>
            <div
              style={{
                display:
                  isRuntime() !== "false" ||
                  this.props.programContainer.EnglishOnly
                    ? "none"
                    : "flex",
                justifyContent: "end",
                marginBottom: "20px",
              }}
            >
              {/* @ts-ignore */}
              <SelectButton
                value={this.props.isEng ? "English" : "French"}
                onChange={(e) => this.props.callBackLang(e.value == "English")}
                options={options}
              />
            </div>

            <div style={{ marginBottom: "7%" }} className="card">
              {/* @ts-ignore */}
              <Steps
                model={items}
                activeIndex={this.state.stepperIndex}
                onSelect={(e) => this.setState({ stepperIndex: e.index })}
                readOnly={false}
              />
            </div>
            <div style={{ display: displayErrorCompoenent ? "block" : "none" }}>
              <ErrorAlertsComponent
                errorMsgList={this.state.validationErrMsg}
                isEng={this.props.isEng}
              ></ErrorAlertsComponent>
            </div>
            <hr></hr>

            <div>
              <SpinnerComponent isBusy={this.state.isBusy} />
            </div>
          </div>,
        );
        break;
      case "hiddenStepper":
        if (!currentSection?.IsTechErrorPage) {
          const topPositionFields =
            SectionUtils.getFieldsAboveTitle(currentSection);
          const element =
            topPositionFields.length > 0 ? topPositionFields[0] : null;
          const htmlToReactParser = new this.HtmlToReactParser();
          StepperHeader.push(
            <div style={{ width: "100%" }}>
              <div
                style={{
                  display:
                    isRuntime() !== "false" ||
                    this.props.programContainer.EnglishOnly
                      ? "none"
                      : "flex",
                  justifyContent: "end",
                  marginBottom: "20px",
                }}
              >
                {/* @ts-ignore */}
                <SelectButton
                  value={this.props.isEng ? "English" : "French"}
                  onChange={(e) =>
                    this.props.callBackLang(e.value == "English")
                  }
                  options={options}
                />
              </div>
              <div>
                <div
                  style={{
                    display:
                      currentSection?.IsInfoPage ||
                      currentSection?.CustomizedReviewPage ||
                      currentSection?.IsTechErrorPage ||
                      currentSection?.IsConfirmationPage
                        ? "none"
                        : "block",
                  }}
                >
                  <StepIndicator
                    withbackbtn={currentSection.NoBackButton !== true}
                    sectionSequence={this.state.stepperIndex}
                    title="Back"
                    section={currentSection}
                    isEng={this.props.isEng}
                    topNavigation={this.props.programContainer.TopNavigation}
                    showReview={this.state.showReview}
                    leftButtons={this.topLeftBtn()}
                    rightButtons={this.topRightBtn()}
                    callback={(currentStep) => {
                      if (currentStep == undefined) {
                        this.setState({
                          stepperIndex: 0,
                          validationErrMsg: [],
                        });
                      } else {
                        const section = this.sortedList[currentStep];
                        this.setState({
                          stepperIndex: currentStep,
                          validationErrMsg: [],
                          showForm: section?.CustomizedReviewPage
                            ? !this.state.showForm
                            : this.state.showForm,
                          showReview: section?.CustomizedReviewPage
                            ? !this.state.showReview
                            : this.state.showReview,
                        });
                      }
                      this.addUrlToHistory(currentStep);
                    }}
                  ></StepIndicator>
                </div>

                <div>
                  {element && (
                    <ElementComponent
                      key={
                        element.LoadBindName +
                        "_ElementComponent_field_" +
                        element.Id
                      }
                      isEng={this.props.isEng}
                      field={element}
                      editable={true}
                      onBusyChange={(isBusy) => {
                        this.setState({ isBusy: isBusy });
                      }}
                      callbackGeneratePdf={() => this.downloadPdfInHorizontal()}
                      callbackElement={(container) => {
                        this.props.callback(container);
                      }}
                    />
                  )}
                </div>

                <div
                  style={{ display: displayErrorCompoenent ? "block" : "none" }}
                  tabIndex={-1}
                  ref={this.errorRef}
                >
                  <ErrorAlertsComponent
                    errorMsgList={this.state.validationErrMsg}
                    isEng={this.props.isEng}
                    fromAPI={this.state.fromAPI}
                  ></ErrorAlertsComponent>
                </div>
                {/* <div style={{ display: currentSection?.IsTerminationPage || currentSection?.IsConfirmationPage || currentSection.CustomizedReviewPage ? "none" : "block" }} */}

                {!currentSection?.TitleInStepIndicator && (
                  <>
                    {currentSection?.ENUTitle &&
                      !currentSection?.setHideTitle && (
                        <h1
                          ref={this.headingRef}
                          tabIndex={-1}
                          style={{
                            display:
                              currentSection?.IsTerminationPage ||
                              currentSection?.CustomizedReviewPage
                                ? "none"
                                : "block",
                          }}
                          className={`ontario-h1 focusable-heading ontario-margin-bottom-0-! div-override-margin ${
                            currentSection?.srOnly ? "sr-only" : ""
                          }`}
                        >
                          {this.isBXP
                            ? replaceStepNumber(
                                this.props.isEng
                                  ? currentSection?.ENUTitle
                                  : currentSection?.FRATitle,
                                this.props.isEng,
                                this.getCurrentBXPStepIndex,
                              )
                            : replaceTitlePlaceholders(
                                this.props.isEng
                                  ? currentSection?.ENUTitle
                                  : currentSection?.FRATitle,
                              )}
                        </h1>
                      )}

                    <p
                      style={{
                        display:
                          currentSection?.IsTerminationPage ||
                          currentSection.CustomizedReviewPage
                            ? "none"
                            : "block",
                      }}
                      className={
                        !currentSection?.IsTerminationPage &&
                        currentSection?.ENUDescription
                          ? "ontario-lead-statement"
                          : ""
                      }
                    >
                      {this.props.isEng
                        ? currentSection?.ENUDescription
                        : currentSection?.FRADescription}
                    </p>
                  </>
                )}
              </div>
              <div>
                <SpinnerComponent isBusy={this.state.isBusy} />
              </div>
            </div>,
          );
        }

        break;
      case "hiddenStepperWithSectionTitle":
        if (!currentSection.NotStep) {
          StepperHeader.push(
            <div className="ontario-margin-top-16-!" style={{ width: "100%" }}>
              <div
                style={{
                  display:
                    isRuntime() !== "false" ||
                    this.props.programContainer.EnglishOnly
                      ? "none"
                      : "flex",
                  justifyContent: "end",
                  marginBottom: "20px",
                }}
              >
                {/* @ts-ignore */}
                <SelectButton
                  value={this.props.isEng ? "English" : "French"}
                  onChange={(e) =>
                    this.props.callBackLang(e.value == "English")
                  }
                  options={options}
                />
              </div>

              <div>
                <span
                  className="ontario-h4"
                  style={{
                    display:
                      !currentSection?.IsFrontPage &&
                      !currentSection?.IsTerminationPage &&
                      !currentSection?.CustomizedReviewPage &&
                      !currentSection?.IsTechErrorPage
                        ? "block"
                        : "none",
                  }}
                >
                  Step&nbsp;
                  {this.state.stepperIndex + 1}&nbsp;of&nbsp;
                  {
                    this.props.programContainer.ListOfFormSections.filter(
                      (p) =>
                        !p.IsFrontPage &&
                        !p.IsTerminationPage &&
                        !p.CustomizedReviewPage &&
                        p.Visible,
                    ).length
                  }
                  :&nbsp;
                  {this.props.isEng
                    ? this.sortedList[this.state.stepperIndex]?.ENUTitle
                    : this.sortedList[this.state.stepperIndex]?.FRATitle}
                </span>
                <hr className="ontario-margin-top-0-! ontario-margin-bottom-36-!" />
              </div>

              <div
                style={{ display: displayErrorCompoenent ? "block" : "none" }}
              >
                <ErrorAlertsComponent
                  errorMsgList={this.state.validationErrMsg}
                  isEng={this.props.isEng}
                ></ErrorAlertsComponent>
              </div>
              <div>
                <SpinnerComponent isBusy={this.state.isBusy} />
              </div>
            </div>,
          );
        }
        break;
      case "NoIndicatorStepper":
        StepperHeader.push(
          <div style={{ width: "100%" }}>
            {/* <StepIndicator withbackbtn={true} currentStep={currentSection.NotStep ? 0 : this.state.stepperIndex} 
                            title="Back" section={currentSection} isEng={this.props.isEng}
                                totalSteps={totalSteps}
                                callback={(currentStep) => { this.setState({ stepperIndex: currentStep, validationErrMsg:[] }) }}>
                            </StepIndicator> */}
            <br></br>
            <div
              style={{
                display:
                  isRuntime() !== "false" ||
                  this.props.programContainer.EnglishOnly
                    ? "none"
                    : "flex",
                justifyContent: "end",
                marginBottom: "20px",
              }}
            >
              {/* @ts-ignore */}
              <SelectButton
                value={this.props.isEng ? "English" : "French"}
                onChange={(e) => this.props.callBackLang(e.value == "English")}
                options={options}
              />
            </div>
          </div>,
        );
        break;
      case "progressBarStepper":
        const stepSections =
          this.props.programContainer.ListOfFormSections.filter(
            (p) => !p.CustomizedReviewPage && !p.IsTechErrorPage,
          );
        if (stepSections.length <= 1) return null;

        let progress = Math.round(
          (100 * this.state.stepperIndex) / (stepSections.length - 1),
        );
        if (progress > 100) {
          progress = 100;
        }
        if (progress > 0) {
          StepperHeader.push(
            <div style={{ width: "100%" }} className="ontario-margin-top-16-!">
              <div
                style={{
                  display:
                    isRuntime() !== "false" ||
                    this.props.programContainer.EnglishOnly
                      ? "none"
                      : "flex",
                  justifyContent: "end",
                  marginBottom: "20px",
                }}
              >
                {/* @ts-ignore */}
                <SelectButton
                  value={this.props.isEng ? "English" : "French"}
                  onChange={(e) =>
                    this.props.callBackLang(e.value == "English")
                  }
                  options={options}
                />
              </div>
              {/* @ts-ignore */}
              <ProgressBar
                title={
                  this.props.isEng
                    ? `current progress: ${progress}`
                    : `Progrès en cours : ${progress}`
                }
                value={progress}
                aria-valuetext={`Loading: ${progress}% complete`}
                // displayValueTemplate={() => `${currentStep}/${stepSections.length}`}
              />
              <hr className="progressbar-separater" />
              <div
                style={{ display: displayErrorCompoenent ? "block" : "none" }}
              >
                <ErrorAlertsComponent
                  errorMsgList={this.state.validationErrMsg}
                  isEng={this.props.isEng}
                ></ErrorAlertsComponent>
              </div>
            </div>,
          );
        }
        break;
    }

    // if (displayErrorCompoenent && this.errorRef.current) {
    //     //  this.errorRef.current.tabIndex = 0;
    //     setTimeout(() => {
    //         this.errorRef.current.focus();
    //     }, 0);
    // }

    return StepperHeader;
  };

  determineSectionVisibility = () => {
    outerLoop: for (let formSection of this.sortedList) {
      if (!formSection.IsConfirmationPage) formSection.Visible = true;
      const filterValueMap = getSectionFilterValueMap(formSection);
      const activeFilters = Object.entries(filterValueMap || {}).filter(
        ([_, v]) => Array.isArray(v) && v.length > 0,
      );
      if (activeFilters.length > 0) {
        let priorSectionList =
          this.props.programContainer.ListOfFormSections.filter(
            (p) => p.Sequence < formSection.Sequence,
          ).sort((a, b) => a.Sequence - b.Sequence);
        middleLoop: for (let priorSection of priorSectionList) {
          for (const [filterFieldName, allowedValues] of activeFilters) {
            const ele = priorSection.findFieldByName(filterFieldName);
            if (ele && ele.Value) {
              let eleAr = ele.Value.split("#");
              if (eleAr.length == 1) {
                eleAr = ele.Value.split("|");
              }
              if (!eleAr.some((value) => allowedValues.includes(value))) {
                formSection.Visible = false;
                break middleLoop;
              }
            }
          }
        }
      }

      // if (formSection && formSection.Visible && formSection.PreScript && formSection.PreScript?.trim().length > 0) {
      //     const customJSFunc = eval(`(${formSection.PreScript})`);
      //     try {
      //         customJSFunc(formSection);
      //     } catch (ex) {
      //         console.log(ex);
      //     }
      // }
      this.execuetPreScript(formSection);
    }
  };

  private getSafeStepperIndex = (index?: number) => {
    const sections =
      this.sortedList || this.props.programContainer?.ListOfFormSections || [];
    if (!sections.length) return 0;

    const numericIndex = Number.isFinite(index) ? (index as number) : 0;
    const clamped = Math.min(Math.max(numericIndex, 0), sections.length - 1);
    const nextVisibleFromClamp = sections.findIndex(
      (section, idx) => idx >= clamped && section?.Visible !== false,
    );
    if (nextVisibleFromClamp >= 0) {
      return nextVisibleFromClamp;
    }
    const firstVisible = sections.findIndex(
      (section) => section?.Visible !== false,
    );
    return firstVisible >= 0 ? firstVisible : 0;
  };

  private ensureStepperIndexIsValid = () => {
    const safeIndex = this.getSafeStepperIndex(this.state.stepperIndex);
    if (safeIndex !== this.state.stepperIndex) {
      this.setState({ stepperIndex: safeIndex });
      return true;
    }
    return false;
  };

  private isCustomizedReviewPageActive = () => {
    const sections =
      this.sortedList || this.props.programContainer?.ListOfFormSections || [];
    if (!sections.length) return false;
    const safeIndex = this.getSafeStepperIndex(this.state.stepperIndex);
    return Boolean(sections[safeIndex]?.CustomizedReviewPage);
  };

  // private loadSectionInitialData = async (section) => {
  //   try {
  //     await this.executeSectionGetAPI(section);
  //   } finally {
  //     this.setState({ sectionDataLoaded: true });
  //   }
  // };

  // executeSectionGetAPI = async (section) => {
  //   if (section == null) return;
  //   if (
  //     section.GetAPI &&
  //     section.GetAPI.trim() != ""
  //   ) {
  //     await axios
  //       .get(section.GetAPI, {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Accept: "application/json",
  //           authorization: `Bearer ${SessionStorageService.getPSToken()}`,
  //         },
  //       })
  //       .then((response) => {
  //         if (response && response.data) {
  //           const data = response.data;
  //           sessionStorage.setItem(`sectionInitialData_${section.Id}`, JSON.stringify(data));
  //         }
  //       });
  //   }
  // };

  previewFormInStepper = () => {
    let stepperBody = [];
    let stepperContent = [];

    if (this.props.programContainer != null) this.sortFormList();

    if (this.sortedList.length == 0) return null;

    const lastVisibleSection = this.sortedList[this.sortedList.length - 1];

    const safeIndex = this.getSafeStepperIndex(this.state.stepperIndex);
    let currentSection = this.sortedList[safeIndex];

    if (!currentSection) {
      return null;
    }

    if (!this.state.sectionDataLoaded && currentSection.GetAPI) {
      return null;
    }

    this.continueButtonHidden =
      lastVisibleSection?.Sequence == currentSection?.Sequence;

    const usesReviewPanel =
      this.props.programContainer.displayForm !== "progressBarStepper";

    if (currentSection != null) {
      //   console.log(currentSection)
      stepperBody.push(
        <HelmetComponent
          key={"helmet_" + this.props.programContainer.CategoryId}
          title={replaceTitlePlaceholders(
            this.props.isEng
              ? currentSection?.ENUTitle
              : currentSection?.FRATitle,
          )}
        />,
      );
      if (currentSection.CustomizedReviewPage) {
        // Set state to show review page when CustomizedReviewPage is detected
        if (usesReviewPanel) {
          if (!this.state.showReview || this.state.showForm) {
            this.setState({ showReview: true, showForm: false });
          }
        } else if (this.state.showReview || !this.state.showForm) {
          this.setState({ showReview: false, showForm: true });
        }
        currentSection.ListOfFormSubSections.forEach((formSubSection) => {
          try {
            if (formSubSection.PreScript?.trim().length > 0) {
              const customJSFunc = eval(`(${formSubSection.PreScript})`);
              customJSFunc(formSubSection, SCRIPT_ENV);
            }
          } catch (ex) {
            console.log(ex);
          }
        });
        if (!usesReviewPanel) {
          // Pass true to bypass showReview check for CustomizedReviewPage
          stepperBody.push(
            this.generateReviewHtmlString(false, true, currentSection),
          );
        }
      } else {
        let optionsFieldValue = new Map<string, string>();
        currentSection.ListOfFormSubSections.forEach((formSubSection) => {
          try {
            if (
              formSubSection.PreScript &&
              formSubSection.PreScript.trim().length > 0
            ) {
              const customJSFunc = eval(`(${formSubSection.PreScript})`);
              customJSFunc(formSubSection, SCRIPT_ENV);
            }
          } catch (ex) {
            console.log(ex);
          }
          this.sectionOptionsFieldValue(formSubSection, optionsFieldValue);
        });
        const stepperHeader = this.stepperHeaderGeneration();
        if (stepperHeader.length > 0) {
          stepperContent.push(stepperHeader);
        }
        const subsectionNumber = currentSection.ListOfFormSubSections.filter(
          (sub) => sub.Visible != false,
        ).length;
        let visibleSubIndex = 0;
        currentSection.ListOfFormSubSections.sort(
          (a, b) => a.Sequence - b.Sequence,
        ).forEach((subSection, subSectionIndex) => {
          let currentFilterValue = subSection.FilterValue;
          if (
            currentFilterValue?.length > 0 &&
            Utils.isNotNullOrEmpty(
              currentFilterValue?.filter((p) => p?.length > 0),
            )
          ) {
            let priorSectionList = currentSection.ListOfFormSubSections.filter(
              (p) => p.Sequence < subSection.Sequence,
            ).sort((a, b) => a.Sequence - b.Sequence);
            middleLoop: for (let priorSection of priorSectionList) {
              for (let i = 0; i < subSection.FilterField.length; i++) {
                let eleReturned;
                priorSection.ListOfFormSectionElements.forEach((ele) => {
                  if (ele.LoadBindName == subSection.FilterField[i]) {
                    eleReturned = ele;
                    return;
                  }
                });
                if (eleReturned && subSection.FilterValue[i]?.length > 0) {
                  if (
                    Utils.isNullOrEmpty(eleReturned.Value) ||
                    !subSection.FilterValue[i].includes(eleReturned.Value)
                  ) {
                    subSection.Visible = false;
                  } else {
                    subSection.Visible = true;
                  }
                  break middleLoop;
                }
              }
            }
          }

          if (currentSection.IsTechErrorPage) {
            delete subSection.Visible;
          }

          if (Utils.isNullOrEmpty(subSection.Visible) || subSection.Visible) {
            let subsectionHtmlString = [];

            // When KeepDuplicatesEditable is true, ALL subsections (original + duplicates) should render as editable form
            // not as DuplicateSubSectionSummary
            const shouldShowAsSummary =
              subSection.ReadOnlyElements &&
              (subSection.IsDuplicate || subSection.CanBeDuplicate) &&
              subSection.KeepDuplicatesEditable !== true;

            if (shouldShowAsSummary) {
              subsectionHtmlString.push(
                <DuplicateSubSectionSummary
                  isEng={this.props.isEng}
                  activeSubSection={subSection}
                  subsecIndex={subSectionIndex}
                  callbackValidate={(errors) => {
                    this.setState({ validationErrMsg: errors }, () =>
                      window.scrollTo({ top: 0, behavior: "smooth" }),
                    );
                  }}
                  callback={(programContainer) => {
                    this.props.callback(programContainer);
                  }}
                />,
              );
            } else {
              const currentSubSection =
                currentSection?.ListOfFormSubSections[subSectionIndex];
              subsectionHtmlString.push(
                !!currentSubSection?.displayInCard ? (
                  <Card
                    className={`inforCard card-container-overrides`}
                    title={
                      this.props?.isEng
                        ? currentSubSection?.ENUTitle
                        : currentSubSection?.FRATitle
                    }
                    content={
                      <>
                        {this.generateSubSectionComponent(
                          subSection,
                          subSectionIndex,
                          optionsFieldValue,
                          currentSection,
                        )}
                      </>
                    }
                  ></Card>
                ) : (
                  <>
                    {this.generateSubSectionComponent(
                      subSection,
                      subSectionIndex,
                      optionsFieldValue,
                      currentSection,
                    )}
                  </>
                ),
              );
            }

            if (subsectionNumber > 1 && subsectionHtmlString.length > 0) {
              // const head = this.props.isEng?subSection.ENUTitle:subSection.FRATitle;
              stepperBody.push(
                <div
                  style={{
                    background: subSection.SubsectionBackground
                      ? subSection.SubsectionBackground
                      : "transparent",
                    padding: subSection.CanBeDuplicate ? "40px" : "0",
                    marginTop: visibleSubIndex === 0 ? "0" : "16px",
                  }}
                >
                  {subsectionHtmlString}
                </div>,
              );
            } else {
              stepperBody.push(subsectionHtmlString);
            }
            visibleSubIndex++;
          }
        });
      }
    }

    if (currentSection?.Background) {
      stepperContent.push(
        <div style={{ background: currentSection.Background }}>
          {stepperBody}
        </div>,
      );
    } else {
      stepperContent.push(...stepperBody);
    }

    return stepperContent;
  };

  private generateSubSectionComponent(
    subSection: FormSubSections,
    subSectionIndex: number,
    optionsFieldValue: Map<string, string>,
    currentSection: FormSections,
  ) {
    return (
      <SubSectionComponent
        key={"sub_" + subSection.Id + "_" + subSectionIndex}
        isEng={this.props.isEng}
        {...this.props}
        activeSubSection={subSection}
        optionsFieldValue={optionsFieldValue}
        returnIndex={this.returnIndex}
        user={this.props.user}
        editable={true}
        renderHeader={
          this.props.programContainer.displayForm !== "NoIndicatorStepper"
        }
        callbackGeneratePdf={(field) => {
          this.downloadPdfInHorizontal();
        }}
        callback={(programContainer) => {
          this.props.callback(programContainer);
        }}
        callbackValidate={(errors, fromAPI) => {
          this.setState({ validationErrMsg: errors, fromAPI: fromAPI }, () => {
            this.props.callback(this.props.programContainer);
            window.scrollTo({ top: 0, behavior: "smooth" });
          });
        }}
        onBusyChange={(isBusy) => {
          this.setState({ isBusy: isBusy });
        }}
        callbackStepIndex={(stepperIndex, returnIndex) => {
          this.returnIndex = returnIndex;
          const section = this.sortedList[stepperIndex];
          if (
            !section?.IsInfoPage &&
            !section?.IsTechErrorPage &&
            !section?.IsConfirmationPage &&
            !section?.NotStep
          ) {
            this.activeStepList.add(stepperIndex);
          }

          currentSection = this.sortedList[stepperIndex];
          this.setState(
            {
              validationErrMsg: [],
              stepperIndex: stepperIndex,
              showForm: !currentSection?.CustomizedReviewPage,
              showReview: currentSection?.CustomizedReviewPage,
            },
            () => {
              // gaPageview({
              //     title: this.props.isEng ? currentSection.ENUTitle : currentSection.FRATitle
              // });
              this.addUrlToHistory(stepperIndex);
              this.props.callback(this.props.programContainer);
              window.scrollTo({ top: 0, behavior: "smooth" });
            },
          );
        }}
      />
    );
  }

  sectionOptionsFieldValue = (
    formSubSection: FormSubSections,
    optionsFieldValue: Map<string, string>,
  ) => {
    formSubSection.ListOfFormSectionElements.forEach((element) => {
      if (element.Datatype === "Row") {
        if (element.subSectionList && element.subSectionList.length > 0) {
          element.subSectionList.forEach((subSection) => {
            this.sectionOptionsFieldValue(subSection, optionsFieldValue);
          });
        }
      }
      if (
        ["RadioButton", "CheckGroup", "Dropdown"].includes(element.Datatype)
      ) {
        if (
          !Utils.isNullOrEmpty(element.LoadBindName) &&
          !Utils.isNullOrEmpty(element.Value)
        ) {
          optionsFieldValue.set(element.LoadBindName, element.Value);
        } else {
          optionsFieldValue.set(element.LoadBindName, "");
        }
      }
    });
  };

  postScript = async (currentSection): Promise<any> => {
    console.log("Current Section");
    console.log(currentSection);
    if (currentSection?.PostScript) {
      console.log(currentSection.PostScript);
      const customJSFunc = eval(`(${currentSection.PostScript})`);
      const returnedValue = await customJSFunc(currentSection, SCRIPT_ENV);
      console.log(returnedValue);
      if (typeof returnedValue == "boolean") {
        if (!returnedValue) {
          this.props.callback(this.props.programContainer);
          return;
        }
      }

      let returnSectionIndex;
      if (typeof returnedValue == "string") {
        returnSectionIndex =
          this.props.programContainer.ListOfFormSections.filter(
            (p) => p.ENUTitle == returnedValue,
          )[0].Sequence - 1;
      } else {
        returnSectionIndex = returnedValue;
      }
      if (returnSectionIndex) {
        await this.setStateAsync({
          validationErrMsg: [],
          stepperIndex: returnSectionIndex,
        });

        this.addUrlToHistory(returnSectionIndex);
        this.props.callback(this.props.programContainer);
        window.scrollTo({ top: 0, behavior: "smooth" });
        return "Transfered";
      }
    }
  };

  setStateAsync(state: any): Promise<void> {
    return new Promise<void>((resolve) => {
      this.setState(state, () => resolve());
    });
  }
  stepperScript = (currentSection) => {
    let destinationIndex;
    if (currentSection.StepperScript) {
      const customJSFunc = eval(`(${currentSection.StepperScript})`);
      customJSFunc((index) => {
        destinationIndex = index - 1;
      });
    }

    return destinationIndex;
  };

  renderReturnToSummaryButton = () => {
    const programContainer = this.props.programContainer;
    if (!programContainer.ReturnToSummaryButton) return null;
    if (!this.state.navigatedFromSummary) return null;

    const currentSection = this.sortedList[this.state.stepperIndex];
    if (!currentSection) return null;

    // Don't show on summary pages or pages after the summary
    const summaryIndex = this.sortedList.findIndex(
      (s) => s.CustomizedReviewPage,
    );
    if (summaryIndex < 0) return null;
    if (this.state.stepperIndex >= summaryIndex) return null;

    const label = this.props.isEng
      ? programContainer.ReturnToSummaryButtonLabel || "Return to summary"
      : programContainer.ReturnToSummaryButtonLabelFRA ||
        programContainer.ReturnToSummaryButtonLabel ||
        "Retour au sommaire";

    return (
      <button
        className="ontario-button ontario-button--secondary"
        type="button"
        onClick={() => {
          this.activeStepList.add(summaryIndex);
          this.addUrlToHistory(summaryIndex);
          this.setState(
            {
              stepperIndex: summaryIndex,
              showForm: false,
              showReview: true,
              navigatedFromSummary: false,
            },
            () => {
              window.scrollTo({ top: 0, behavior: "smooth" });
            },
          );
        }}
      >
        {label}
      </button>
    );
  };

  continueBtn = () => {
    if (this.props.programContainer != null) this.sortFormList();

    const currentSection = this.sortedList[this.state.stepperIndex];

    if (
      !currentSection ||
      currentSection?.NoDefaultContinue ||
      currentSection?.NotStep ||
      [
        "IsTechErrorPage",
        "IsTerminationPage",
        "IsFrontPage",
        "IsInfoPage",
        "IsConfirmationPage",
      ].some((key) => currentSection[key])
    ) {
      return null;
    }
    let stepperIndex = this.state.stepperIndex;
    const showSaveLater =
      this.props.programContainer?.saveLaterEnabled === true;
    const keepContinueLeft = currentSection?.KeepContinueButtonLeft;
    const hasRuntimeCancelButton =
      currentSection?.ListOfFormSubSections?.some((sub) =>
        sub?.ListOfFormSectionElements?.some(
          (el) => el?.IsCancelButton && el?.Visible !== false,
        ),
      ) === true;
    const hasRuntimeSaveDraftButton =
      currentSection?.ListOfFormSubSections?.some((sub) =>
        sub?.ListOfFormSectionElements?.some(
          (el) => el?.IsSaveDraftButton && el?.Visible !== false,
        ),
      ) === true;
    const alignContinueLeft = !!(
      keepContinueLeft &&
      (showSaveLater ||
        hasRuntimeCancelButton ||
        hasRuntimeSaveDraftButton ||
        ((this.props.programContainer?.CategoryId || "")
          .toUpperCase()
          .startsWith("BXP") &&
          this.state.stepperIndex !== 0))
    );

    const cancelButtons =
      currentSection?.ListOfFormSubSections?.flatMap(
        (sub) => sub?.ListOfFormSectionElements || [],
      )?.filter(
        (el) =>
          el?.Datatype === "Button" &&
          el?.IsCancelButton &&
          el?.Visible !== false,
      ) || [];
    const saveDraftButtons =
      currentSection?.ListOfFormSubSections?.flatMap(
        (sub) => sub?.ListOfFormSectionElements || [],
      )?.filter(
        (el) =>
          el?.Datatype === "Button" &&
          el?.IsSaveDraftButton &&
          el?.Visible !== false,
      ) || [];

    const continueButton = (
      <button
        className="ontario-button ontario-button--primary"
        style={{ order: alignContinueLeft ? -1 : undefined }}
        onClick={() => {
          if (currentSection.StepperScript) {
            stepperIndex = this.stepperScript(currentSection);
          }
          if (currentSection?.PreScript) {
            const customJSFunc = eval(`(${currentSection.PreScript})`);
            customJSFunc(currentSection, SCRIPT_ENV);
          }
          this.handleContinueClick(currentSection, stepperIndex);
        }}
      >
        {this.props.isEng
          ? currentSection?.NextButtonLabel
            ? currentSection?.NextButtonLabel
            : "Continue"
          : currentSection?.NextButtonLabelFRA
            ? currentSection?.NextButtonLabelFRA
            : "Continuer"}
      </button>
    );

    const saveAndContinueButton =
      showSaveLater && this.props.programContainer?.Profile ? (
        <button
          className="ontario-button ontario-button--secondary"
          type="button"
          disabled={this.state.isBusy}
          onClick={this.handleSaveAndContinueLater}
        >
          {this.props.isEng
            ? "Save and continue later"
            : this.props.programContainer?.CategoryId === "vecon"
              ? "Enregistrer et poursuivre plus tard"
              : "Enregistrer et continuer plus tard"}
        </button>
      ) : null;

    const loginToSaveButton =
      showSaveLater && !this.props.programContainer?.Profile ? (
        <button
          className="ontario-button ontario-button--secondary"
          type="button"
          disabled={this.state.isBusy}
          onClick={this.handleLoginToSaveDraft}
        >
          {this.props.isEng
            ? "Log in to save a draft"
            : "Ouvrir une session pour enregistrer une ébauche"}
        </button>
      ) : null;

    const bxpSaveDraftButton = (this.props.programContainer?.CategoryId || "")
      .toUpperCase()
      .startsWith("BXP") ? (
      <button
        className="ontario-button ontario-button--secondary"
        id="save-draft-btn"
        type="button"
        aria-label="Save as draft"
        style={{
          display: this.state.stepperIndex === 0 ? "none" : "block",
        }}
        onClick={(e) => {
          this.saveToServer(false);
        }}
      >
        {this.props.isEng ? "Save as draft" : "Sauvegarder"}
      </button>
    ) : null;

    const buttonOrder = alignContinueLeft
      ? [
          continueButton,
          saveAndContinueButton,
          loginToSaveButton,
          bxpSaveDraftButton,
          ...saveDraftButtons.map((btn) => {
            (btn as any)._renderedInline = true;
            return (
              <RuntimeButtonComponent
                key={`savedraft-inline-${btn.Id}`}
                field={btn}
                editable={true}
                forceRenderCancelInline={true}
                title={this.props.isEng ? btn.ENUTitle : btn.FRATitle}
                labelControlArray={[]}
                requiredField={false}
                isEng={this.props.isEng}
                callback={(programContainer) =>
                  this.props.callback(programContainer)
                }
                callbackStepIndex={(index) =>
                  this.setState({ stepperIndex: index })
                }
                callbackValidate={(errors) =>
                  this.setState({ validationErrMsg: errors || [] })
                }
              />
            );
          }),
          ...cancelButtons.map((btn) => {
            (btn as any)._renderedInline = true;
            return (
              <RuntimeButtonComponent
                key={`cancel-inline-${btn.Id}`}
                field={btn}
                editable={true}
                forceRenderCancelInline={true}
                title={this.props.isEng ? btn.ENUTitle : btn.FRATitle}
                labelControlArray={[]}
                requiredField={false}
                isEng={this.props.isEng}
                callback={(programContainer) =>
                  this.props.callback(programContainer)
                }
                callbackStepIndex={(index) =>
                  this.setState({ stepperIndex: index })
                }
                callbackValidate={(errors) =>
                  this.setState({ validationErrMsg: errors || [] })
                }
              />
            );
          }),
          this.renderReturnToSummaryButton(),
        ]
      : [
          continueButton,
          saveAndContinueButton,
          loginToSaveButton,
          bxpSaveDraftButton,
          ...saveDraftButtons.map((btn) => {
            (btn as any)._renderedInline = true;
            return (
              <RuntimeButtonComponent
                key={`savedraft-inline-${btn.Id}`}
                field={btn}
                editable={true}
                forceRenderCancelInline={true}
                title={this.props.isEng ? btn.ENUTitle : btn.FRATitle}
                labelControlArray={[]}
                requiredField={false}
                isEng={this.props.isEng}
                callback={(programContainer) =>
                  this.props.callback(programContainer)
                }
                callbackStepIndex={(index) =>
                  this.setState({ stepperIndex: index })
                }
                callbackValidate={(errors) =>
                  this.setState({ validationErrMsg: errors || [] })
                }
              />
            );
          }),
          ...cancelButtons.map((btn) => {
            (btn as any)._renderedInline = true;
            return (
              <RuntimeButtonComponent
                key={`cancel-inline-${btn.Id}`}
                field={btn}
                editable={true}
                forceRenderCancelInline={true}
                title={this.props.isEng ? btn.ENUTitle : btn.FRATitle}
                labelControlArray={[]}
                requiredField={false}
                isEng={this.props.isEng}
                callback={(programContainer) =>
                  this.props.callback(programContainer)
                }
                callbackStepIndex={(index) =>
                  this.setState({ stepperIndex: index })
                }
                callbackValidate={(errors) =>
                  this.setState({ validationErrMsg: errors || [] })
                }
              />
            );
          }),
          this.renderReturnToSummaryButton(),
        ];

    return (
      <div
        className="ontario-margin-top-32-! form-action-buttons"
        style={{
          display: "flex",
          gap: "12px",
          justifyContent: alignContinueLeft ? "flex-start" : undefined,
          flexWrap: alignContinueLeft ? "wrap" : undefined,
        }}
      >
        {buttonOrder.filter(Boolean)}
      </div>
    );
  };

  updateTopButtonVisibility = () => {
    const doc = document.documentElement || document.body;
    const scrollHeight = doc?.scrollHeight || 0;
    const clientHeight = doc?.clientHeight || 0;
    const canScroll = scrollHeight - clientHeight > 20;
    const scrolled = window.scrollY > 16;
    const shouldShow = canScroll && scrolled;
    if (this.state.showTopButton !== shouldShow) {
      this.setState({ showTopButton: shouldShow });
    }
  };

  renderTopButton = () => {
    if (!this.state.showForm) return null;

    if (this.props.programContainer != null) this.sortFormList();
    const currentSection =
      this.sortedList && this.sortedList[this.state.stepperIndex];

    if (!currentSection?.HaveTopButton) return null;

    const isVisible = this.state.showTopButton;

    return (
      <button
        type="button"
        className="ontario-back-to-top--default active"
        aria-label={
          this.props.isEng ? "Scroll back to the top" : "Retour en haut"
        }
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        style={{ display: isVisible ? "flex" : "none" }}
      >
        <span aria-hidden="true">
          <svg
            className="ontario-icon"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="#000000"
          >
            <path d="M0 0h24v24H0V0z" fill="none"></path>
            <path d="M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"></path>
          </svg>
        </span>
        {this.props.isEng ? "Top" : "Haut"}
      </button>
    );
  };

  handleSaveAndContinueLater = async () => {
    this.setState({ isBusy: true });
    const langSegment = this.props.isEng ? "en" : "fr";
    const exitUrl = sessionStorage.getItem("exitUrl") || "/drafts";
    const redirectUrl = `${getEnvVar("PUBLIC_CXP_WEB_BASE_PATH")}/${langSegment}${exitUrl}`;
    try {
      const success = await DataUtils.saveDraft(this.props.programContainer);
      if (this.growl) {
        if (success) {
          this.growl.show({
            severity: "success",
            summary: this.props.isEng ? "Draft saved" : "Brouillon enregistre",
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: this.props.isEng
              ? "Save failed"
              : "Echec de la sauvegarde",
          });
        }
      }
    } finally {
      this.setState({ isBusy: false }, () => {
        sessionStorage.removeItem(
          `draft_${this.props.programContainer.CategoryId}`,
        );
        sessionStorage.removeItem(
          `draftId_${this.props.programContainer.CategoryId}`,
        );
        SectionUtils.resetDirtyFlags(this.props.programContainer);
        window.location.href = redirectUrl;
      });
    }
  };

  handleLoginToSaveDraft = async () => {
    this.setState({ isBusy: true });
    try {
      const savedToSession = await DataUtils.saveDraftToSession(
        this.props.programContainer,
      );
      if (!savedToSession) {
        throw new Error("Unable to cache draft before login");
      }

      sessionStorage.setItem(
        "pendingDraftAppId",
        this.props.programContainer.CategoryId,
      );
      sessionStorage.setItem("redirectToDrafts", "true");

      const isEng = this.props.isEng;
      const langSegment = isEng ? "en" : "fr";
      const cxpBase = (getEnvVar("PUBLIC_CXP_WEB_BASE_PATH") || "").replace(
        /\/+$/,
        "",
      );
      const redirectUri = normalizeCxpRedirectPath(
        `${window.location.pathname}${window.location.search}`,
      );
      SectionUtils.resetDirtyFlags(this.props.programContainer);
      window.location.replace(
        `${cxpBase}/${langSegment}/auth/signin?redirectUri=${encodeURIComponent(
          redirectUri,
        )}`,
      );
    } catch (error) {
      console.error("Unable to stash draft before login:", error);
      sessionStorage.removeItem("pendingDraftAppId");
      sessionStorage.removeItem("redirectToDrafts");
      const isEng = this.props.isEng;
      const langSegment = isEng ? "en" : "fr";
      const cxpBase = getEnvVar("PUBLIC_CXP_WEB_BASE_PATH");
      const redirectUri = normalizeCxpRedirectPath(
        `${window.location.pathname}${window.location.search}`,
      );
      SectionUtils.resetDirtyFlags(this.props.programContainer);
      window.location.replace(
        `${cxpBase}/${langSegment}/auth/signin?redirectUri=${encodeURIComponent(
          redirectUri,
        )}`,
      );
    } finally {
      this.setState({ isBusy: false });
    }
  };

  handleContinueClick = async (
    currentSection: FormSections,
    stepperIndex: number,
  ) => {
    if (
      currentSection?.ContinueScript &&
      currentSection.ContinueScript.trim().length > 0
    ) {
      try {
        const customJSFunc = eval(`(${currentSection.ContinueScript})`);
        if (typeof customJSFunc === "function") {
          const result = customJSFunc(currentSection, SCRIPT_ENV);
          if (result === false) {
            return;
          }
          if (Array.isArray(result) && result.length > 0) {
            result.forEach((field) => {
              field.Touched = true;
            });
            this.setState({ validationErrMsg: result }, () => {
              window.scrollTo({ top: 0, behavior: "smooth" });
            });
            return;
          }
        }
      } catch (ex) {
        console.log(ex);
      }
    }

    if (!currentSection.IsTerminationPage) {
      let invalidControlList =
        FormValidationUtils.invalidControls(currentSection);
      if (invalidControlList.length > 0) {
        invalidControlList.forEach((field) => {
          field.Touched = true;
        });
        this.setState({ validationErrMsg: invalidControlList }, () => {
          window.scrollTo({ top: 0, behavior: "smooth" });
        });
      } else {
        this.setState({ validationErrMsg: [] });
        let nextSection: FormSections;
        this.determineSectionVisibility();
        for (let i = 0; i < 10; i++) {
          stepperIndex++;

          nextSection = this.sortedList[stepperIndex];

          if (
            !nextSection &&
            !SectionUtils.HasCustimzedSummary(this.props.programContainer)
          ) {
            this.setState(
              {
                showForm: false,
                showReview: true,
                validationErrMsg: [],
              },
              () => {
                window.scrollTo({ top: 0 });
              },
            );
            break;
          }

          const postScriptResult = await this.postScript(currentSection);

          if (postScriptResult == "Transfered") {
            return;
          }

          this.execuetPreScript(nextSection);
          this.preScriptedStepIndex = stepperIndex;

          if (nextSection?.CustomizedReviewPage) {
            this.activeStepList.add(stepperIndex);
            this.setState({ showReview: true, showForm: false });
            this.addUrlToHistory(stepperIndex);
            const title = this.props.isEng
              ? currentSection.ENUTitle
              : currentSection.FRATitle;
            // gaPageview({title})
            break;
          }
          if (nextSection?.Visible) {
            const title = this.props.isEng
              ? currentSection.ENUTitle
              : currentSection.FRATitle;
            this.activeStepList.add(stepperIndex);
            this.setState(
              {
                validationErrMsg: [],
                stepperIndex: stepperIndex,
              },
              () => {
                this.addUrlToHistory(stepperIndex);
                // gaPageview({title})
                this.props.callback(this.props.programContainer);
                window.scrollTo({ top: 0, behavior: "smooth" });
              },
            );

            break;
          }
        }
      }

      if (this.errorRef?.current) {
        //  this.errorRef.current.tabIndex = 0;
        setTimeout(() => {
          this.errorRef?.current?.focus();
        }, 0);
      }
    }

    // await this.postScript(currentSection);
  };

  handleGoToFirstSection = (
    currentSection: FormSections,
    stepperIndex: number,
  ) => {
    // Reset validation errors
    this.setState({ validationErrMsg: [] });

    // Update the stepper index to the first section
    this.setState({ stepperIndex: stepperIndex }, () => {
      // Scroll to the top of the page
      window.scrollTo({ top: 0, behavior: "smooth" });

      // Update the URL history to reflect the first section
      this.addUrlToHistory(stepperIndex);

      // Callback to update the program container
      this.props.callback(this.props.programContainer);
    });
  };

  handleLoadTestData = async () => {
    this.props.programContainer.ListOfFormSections.forEach((formSection) => {
      if (!formSection.NotStep) {
        formSection.ListOfFormSubSections.forEach((subSection) => {
          subSection.ListOfFormSectionElements.forEach((ele) => {
            //console.log(q.ENUTitle, q.Datatype);

            this.setTestData(ele);
          });
        });
      }
    });
    this.setState({ validationErrMsg: [] }, () => {
      this.props.callback(this.props.programContainer);
    });
  };

  setTestData = async (ele: FormSectionElements) => {
    if (ele.Datatype === "Row") {
      if (ele.subSectionList && ele.subSectionList.length > 0) {
        ele.subSectionList.forEach((sub: FormSubSections) => {
          sub.ListOfFormSectionElements.forEach((el: FormSectionElements) => {
            this.setTestData(el);
          });
        });
      }
    }

    switch (ele.Datatype) {
      case "Text":
        ele.Value = faker.word.noun();
        break;
      case "SelectWithRichText":
      case "MultiText":
        ele.Value = faker.word.words(20);
        break;
      case "PostalCode":
        ele.Value = faker.helpers.arrayElement(["M5B 2B8", "M5C 4C3"]);
        break;
      case "PhoneNumber":
        ele.Value =
          "416" + faker.number.int({ min: 2000000, max: 9999999 }).toString();
        break;
      case "Date":
        ele.Value = faker.date.future();
        break;
      case "Number":
        ele.Value = faker.number.int({ min: 1, max: 100 }).toString();
        break;
      case "Checkbox":
        ele.Value =
          ele.Optional === "N" ? "Y" : faker.helpers.arrayElement(["Y", "N"]);
      case "CheckGroup":
      case "RadioButton":
      case "Dropdown":
        if (ele.ListOfLOVValues && ele.ListOfLOVValues.length > 0) {
          const lst = ele.ListOfLOVValues.filter((item) =>
            Utils.isNotNullOrEmpty(item.code),
          );
          if (lst.length > 0)
            ele.Value =
              lst[faker.number.int({ min: 0, max: lst.length - 1 })].code;
        }
        break;
      case "Email":
        ele.Value = faker.internet.email();
        break;
    }
  };

  topLeftBtn = () => {
    if (this.props.programContainer != null) this.sortFormList();

    const currentSection = this.sortedList[this.state.stepperIndex];

    if (
      !currentSection ||
      currentSection?.NotStep ||
      [
        "IsTechErrorPage",
        "IsTerminationPage",
        "IsFrontPage",
        "IsInfoPage",
        "IsConfirmationPage",
      ].some((key) => currentSection[key])
    ) {
      return null;
    }
    let stepperIndex = this.state.stepperIndex;

    return (
      <>
        {this.state.showForm && this.props.programContainer.TopNavigation && (
          <>
            <CustomButton
              appearance="stepIndicatorBtn"
              forwardIcon={true}
              onClick={() =>
                this.handleContinueClick(currentSection, stepperIndex)
              }
            >
              Next
            </CustomButton>

            {stepperIndex == 0 && getEnvVar("NODE_ENV") == "development" && (
              <CustomButton
                appearance="stepIndicatorBtn"
                forwardIcon={false}
                backIcon={false}
                onClick={() => this.handleLoadTestData()}
              >
                Load Test Data
              </CustomButton>
            )}
          </>
        )}
        {this.state.showReview && this.props.programContainer.TopNavigation && (
          <>
            <CustomButton
              appearance="stepIndicatorBtn"
              forwardIcon={false}
              backIcon={false}
              onClick={() => {
                this.setState({ showReview: false, showForm: true });
                window.scrollTo(0, 0);
              }}
            >
              {this.props.isEng ? "Back" : "Retour"}
            </CustomButton>
            <CustomButton
              appearance="stepIndicatorBtn"
              forwardIcon={false}
              backIcon={false}
              onClick={() => {
                this.setState({ showReview: false, showForm: true });
                window.scrollTo(0, 0);
                this.handleGoToFirstSection(currentSection, 0);
              }}
            >
              {this.props.isEng ? "Update" : "Mettre à jou"}
            </CustomButton>
          </>
        )}
      </>
    );
  };

  topRightBtn = () => {
    if (this.props.programContainer != null) this.sortFormList();

    const currentSection = this.sortedList[this.state.stepperIndex];

    if (
      !currentSection ||
      currentSection?.NotStep ||
      [
        "IsTechErrorPage",
        "IsTerminationPage",
        "IsFrontPage",
        "IsInfoPage",
        "IsConfirmationPage",
      ].some((key) => currentSection[key])
    ) {
      return null;
    }
    return this.props.programContainer.TopNavigation ? (
      <div>
        <button
          className="ontario-button ontario-button--primary"
          style={{
            display: this.state.showForm === true ? "none" : "block",
            margin: 0,
          }}
          onClick={(e) => {
            this.props.programContainer.EmailCopy
              ? this.sendAsEmail()
              : this.saveToServer(true);
          }}
        >
          {this.props.isEng ? "Submit" : "Envoyer"}
        </button>
        <button
          className="ontario-button ontario-button--primary"
          style={{
            display: this.state.isComplete || false ? "none" : "block",
            margin: 0,
          }}
          onClick={(e) => {
            this.saveToServer(false);
          }}
        >
          {this.props.isEng ? "Save as draft" : "Envoyer"}
        </button>
        <button
          className="ontario-button ontario-button--primary"
          style={{
            display: this.state.isComplete || false ? "none" : "block",
            margin: 0,
          }}
          disabled={this.state.showForm === true}
          onClick={async () => {
            if (this.state.showForm === true) {
              if (this.props.isEng) {
                alert(
                  "One or more of the items in this form contains an invalid value.",
                );
              } else {
                alert(
                  "Un ou plusieurs éléments de ce formulaire contiennent une valeur non valide.",
                );
              }
              return;
            }

            const url = await this.downloadPDF2();
            this.setState({ pdfFileUrl: url, showPrintDialog: true });
          }}
        >
          {this.props.isEng ? "Print" : "Envoyer"}
        </button>
        <button
          className="ontario-button ontario-button--primary"
          style={{
            display: this.state.isComplete || false ? "none" : "block",
            margin: 0,
          }}
          onClick={(e) => {}}
        >
          {this.props.isEng ? "Help" : "Envoyer"}
        </button>
      </div>
    ) : (
      ""
    );
  };

  execuetPreScript = (formSection) => {
    if (
      formSection &&
      formSection.Visible &&
      formSection.PreScript &&
      formSection.PreScript?.trim().length > 0
    ) {
      const customJSFunc = eval(`(${formSection.PreScript})`);
      try {
        customJSFunc(formSection);
        // Only run for regulated-personnel form to avoid affecting other forms that may use the same section title.
        const programContainer = formSection?.parent;
        const normalizedSectionTitle = String(formSection?.ENUTitle || "")
          .toLowerCase()
          .replace(/\s+/g, " ")
          .trim();
        const isEditCertificationDetailsSection =
          normalizedSectionTitle === "edit certifications details" ||
          normalizedSectionTitle === "edit certification details";
        const isRegulatedPersonnelCertStep =
          programContainer?.CategoryId === "regulated-personnel-local-test" ||
          programContainer?.CategoryId === "regulated-personnel-local";
        if (
          isRegulatedPersonnelCertStep &&
          isEditCertificationDetailsSection &&
          formSection.ListOfFormSubSections?.length
        ) {
          const root = formSection.parent;
          const tableRows = root?.clickedRowDataByTable
            ? Object.values(root.clickedRowDataByTable)
            : [];
          const entity =
            root?.clickedRowDataByTable?.summary ??
            root?.clickedRowData ??
            tableRows.find((row) => !!row) ??
            root?.Entity;
          if (root && entity) {
            const existingAllCerts = Array.isArray(entity.allCertifications)
              ? entity.allCertifications
              : [];
            const certListMergeMap = new Map<string, any>();

            const toCertKey = (cert: any) =>
              [
                String(cert?.certificationType || "")
                  .toUpperCase()
                  .trim(),
                String(
                  cert?.certificateNumber || cert?.certificationNumber || "",
                )
                  .toUpperCase()
                  .trim(),
                String(cert?.startDate || cert?.issueDate || "").trim(),
                String(cert?.validDate || cert?.expiryDate || "").trim(),
              ].join("|");

            const addCert = (cert: any, fallbackType: string) => {
              if (!cert) return;
              const normalizedCert = {
                ...cert,
                certificationType:
                  cert.certificationType || cert.type || fallbackType,
              };
              certListMergeMap.set(toCertKey(normalizedCert), normalizedCert);
            };

            existingAllCerts.forEach((cert) => addCert(cert, ""));
            (entity.firstAidCertificationList || []).forEach((cert) =>
              addCert(cert, "First Aid"),
            );
            (entity.cprCertificationList || []).forEach((cert) =>
              addCert(cert, "CPR"),
            );
            (entity.bhCertificationList || []).forEach((cert) =>
              addCert(cert, "Base Hospital"),
            );

            if (certListMergeMap.size > 0) {
              entity.allCertifications = Array.from(certListMergeMap.values());
            }

            let role = (
              entity.primaryRoleName ||
              (entity.roleList?.[0]?.role ??
                entity.roleList?.[0]?.primaryRoleName) ||
              ""
            )
              .toString()
              .toUpperCase()
              .replace(/\s+/g, " ")
              .trim();
            if (role === "AP") role = "ACP";
            if (role === "QPO") role = "QUALITY PROGRAM OFFICER";
            const allCerts = entity.allCertifications || [];
            const hasCertifications = !!(
              allCerts.length > 0 ||
              entity.cprCertificationList?.[0] ||
              entity.firstAidCertificationList?.[0] ||
              entity.bhCertificationList?.[0] ||
              entity.tdgCertificateStartDate ||
              entity.tdgCertificateValid ||
              entity.areomedCertificateNumber ||
              entity.aircraftTrainingCertificateValid
            );
            const hasFirstAidData = !!(
              entity.firstAidCertificationList?.[0] ||
              (allCerts.length > 0 &&
                allCerts.some((c) =>
                  String(c.certificationType || "")
                    .toUpperCase()
                    .includes("FIRST AID"),
                ))
            );
            const hasCprData = !!(
              entity.cprCertificationList?.[0] ||
              (allCerts.length > 0 &&
                allCerts.some((c) =>
                  String(c.certificationType || "")
                    .toUpperCase()
                    .includes("CPR"),
                ))
            );
            const hasBhData = !!(
              entity.bhCertificationList?.[0] ||
              (allCerts.length > 0 &&
                allCerts.some((c) =>
                  String(c.certificationType || "")
                    .toUpperCase()
                    .includes("BASE HOSPITAL"),
                ))
            );
            const isNoCert =
              role && NO_CERT_ROLES.indexOf(role) >= 0 && !hasCertifications;
            formSection.ListOfFormSubSections.forEach((sub) => {
              if (!KNOWN_BLOCK_IDS.has(sub.BlockId)) {
                sub.Visible = false;
                return;
              }
              if (sub.BlockId === "buttons" || sub.BlockId === "baseHospital") {
                sub.Visible = true;
                return;
              }
              if (isNoCert) {
                sub.Visible = false;
                return;
              }
              let show = false;
              if (NO_CERT_ROLES.indexOf(role) >= 0 && hasCertifications) {
                show =
                  (sub.BlockId === "cpr" && hasCprData) ||
                  (sub.BlockId === "firstAid" && hasFirstAidData) ||
                  (sub.BlockId === "baseHospital" && hasBhData) ||
                  (sub.BlockId === "tdg" &&
                    !!(
                      entity.tdgCertificateStartDate ||
                      entity.tdgCertificateValid
                    )) ||
                  (sub.BlockId === "aeromed" &&
                    !!entity.areomedCertificateNumber) ||
                  (sub.BlockId === "aircraft" &&
                    !!entity.aircraftTrainingCertificateValid);
              } else {
                const roles = VISIBLE_FOR_ROLE[sub.BlockId];
                show = roles ? roles.indexOf(role) >= 0 : false;
              }
              sub.Visible = show;
            });
          }
        }
      } catch (ex) {
        console.log(ex);
      }
    }
  };

  stepperBtn = () => {
    if (this.sortedList.length == 0) return null;
    let currentSection = this.sortedList[this.state.stepperIndex];
    const showSaveLater =
      this.props.programContainer?.saveLaterEnabled === true;
    return (
      <div
        style={{
          display: currentSection?.IsFrontPage ? "none" : "flex",
          justifyContent: "space-between",
        }}
      >
        <button
          className="ontario-button ontario-button--secondary"
          style={{
            visibility: this.state.stepperIndex == 0 ? "hidden" : "visible",
          }}
          onClick={() => {
            let stepperIndex = this.state.stepperIndex;
            this.setState({ validationErrMsg: [] });
            let prevSection: FormSections;
            for (let i = 0; i < 6; i++) {
              stepperIndex--;
              prevSection = this.sortedList[stepperIndex];
              if (prevSection.Visible) {
                break;
              }
            }
            this.setState({ stepperIndex: stepperIndex }, () => {
              const firstHeader = document.querySelector("h1");
              window.scrollTo({ top: 0, behavior: "smooth" });
              // Check if an <h1> element was found and focus on it
              if (firstHeader) {
                firstHeader.focus();
              }
            });
            // gaEvent({
            //     action: 'click',
            //     category: 'Step Back',
            //     label: this.props.isEng ? currentSection.ENUTitle : currentSection.FRATitle,
            // }, this.gaTrackingId);
          }}
        >
          {this.props.isEng ? "Back" : "Précédent"}
        </button>

        <button
          className="ontario-button ontario-button--secondary"
          style={{
            display:
              this.state.isComplete ||
              this.EditableFieldsInForm() == false ||
              this.props.programContainer.NoClearButton == "Y"
                ? "none"
                : "block",
          }}
          onClick={() => {
            let stepperIndex = this.state.stepperIndex;
            currentSection = this.sortedList[stepperIndex];
            this.clearCurrentForm();
            this.props.callback(this.props.programContainer);
          }}
        >
          {this.props.isEng ? "Clear" : "Vider"}
        </button>

        <button
          className="ontario-button ontario-button--secondary"
          style={{
            display:
              showSaveLater &&
              !this.state.isComplete &&
              this.props.programContainer?.Profile
                ? "block"
                : "none",
          }}
          disabled={this.state.isBusy}
          onClick={this.handleSaveAndContinueLater}
        >
          {this.props.isEng
            ? "Save and continue later"
            : this.props.programContainer?.CategoryId === "vecon"
              ? "Enregistrer et poursuivre plus tard"
              : "Enregistrer et continuer plus tard"}
        </button>

        <button
          className="ontario-button ontario-button--secondary"
          style={{
            display:
              this.state.isComplete ||
              this.props.programContainer.HasSaveDraftButton != "Y"
                ? "none"
                : "block",
          }}
          onClick={() => {
            this.saveToServer(false);
          }}
        >
          {this.props.isEng ? "Save a draft" : "Enregistrer un brouillon"}
        </button>

        <button
          className="ontario-button ontario-button--primary"
          style={{
            display:
              (this.continueButtonHidden &&
                this.props.programContainer.NoReview !== "Y") ||
              currentSection.IsTerminationPage
                ? "none"
                : "block",
          }}
          onClick={() => {
            this.nextClickHandler(currentSection);
          }}
        >
          {currentSection.IsTerminationPage
            ? this.props.isEng
              ? "Leave Application"
              : "Quitter"
            : this.props.isEng
              ? "Next"
              : "Suivant"}
        </button>

        <a
          className="ontario-button ontario-button--primary"
          href={
            this.props.isEng
              ? this.props.programContainer.RedirectURL ||
                getEnvVar("SERVICEONTARIO_URL")
              : this.props.programContainer.RedirectURLFRA ||
                getEnvVar("SERVICEONTARIO_URL_F")
          }
          rel="noreferrer"
          style={{
            display: currentSection.IsTerminationPage ? "block" : "none",
          }}
          onClick={() => {
            this.nextClickHandler(currentSection);
          }}
        >
          {this.props.isEng ? "Leave Application" : "Quitter"}
        </a>
        {this.renderReturnToSummaryButton()}
        <div
          style={{
            display:
              this.state.showForm &&
              "Y" !== this.props.programContainer.NoReview &&
              true !== currentSection.IsTerminationPage &&
              this.state.stepperIndex == this.sortedList.length - 1
                ? "block"
                : "none",
          }}
        >
          <button
            className="ontario-button ontario-button--primary"
            onClick={(e) => {
              currentSection = this.sortedList[this.state.stepperIndex];
              let invalidControlList =
                FormValidationUtils.invalidControls(currentSection);
              if (invalidControlList.length > 0) {
                invalidControlList.forEach((field) => {
                  field.Touched = true;
                });
                this.setState({ validationErrMsg: invalidControlList });
              } else {
                this.setState({ showReview: true, showForm: false });
                window.scrollTo(0, 0);
              }
              // gaEvent({
              //     category: 'Review',
              //     action: 'Click',
              //     label: this.props.isEng ? currentSection.ENUTitle : currentSection.FRATitle
              // }, this.gaTrackingId);
            }}
          >
            {this.props.isEng ? "Review" : "Révision"}
          </button>
        </div>
      </div>
    );
  };

  nextClickHandler = (currentSection) => {
    let stepperIndex = this.state.stepperIndex;

    if (currentSection.PostScript) {
      const customJSFunc = eval(`(${currentSection.PostScript})`);
      const returnedValue = customJSFunc(currentSection, SCRIPT_ENV);
      if (typeof returnedValue == "boolean") {
        if (!returnedValue) {
          this.props.callback(this.props.programContainer);
          return;
        }
      }
      if (typeof returnedValue == "number") {
        this.setState({ stepperIndex: returnedValue });
        this.props.callback(this.props.programContainer);
        return;
      }
    }

    if (currentSection.IsTerminationPage) {
      this.setState({ validationErrMsg: [], stepperIndex: 0 });
      sendRatingAndFeedbackToGA(
        currentSection,
        this.gaTrackingId,
        this.props.isEng ? "en" : "fr",
      );
      sendSummaryInfoToGA(currentSection, this.props.isEng ? "en" : "fr");
      // window.location.replace('https://www.ontario.ca/page/serviceontario');
      return null;
    } else {
      currentSection = this.sortedList[stepperIndex];
      // this.scanCurretForm();
      let invalidControlList =
        FormValidationUtils.invalidControls(currentSection);
      if (invalidControlList.length > 0) {
        invalidControlList.forEach((field) => {
          field.Touched = true;
        });
        this.setState({ validationErrMsg: invalidControlList }, () => {
          const firstHeader = document.querySelector(
            "#error-container",
          ) as HTMLDivElement;
          if (firstHeader) {
            firstHeader.focus();
          } else {
            focusOnFirstErrorElement();
          }
        });
      } else {
        //if GA tracking is needed we track each page
        const value =
          this.props.programContainer.sendPageDataToGA !== false
            ? getQuizGaData(currentSection, this.props.isEng ? "en" : "fr")
            : undefined;
        const label = this.props.isEng
          ? currentSection.ENUTitle
          : currentSection.FRATitle;
        // if (!value) {
        //     gaEvent({
        //         category: 'Next',
        //         action: 'Click',
        //         label: label,
        //     }, this.gaTrackingId);
        // } else {
        //     gaCustomEvent('Go to next page', {
        //         label: label,
        //         [label + ': expected values']: value.expectedValues.join(', ') ?? '',
        //         [label + ': exact values']: value.exactValues.join(', '),
        //     }, this.gaTrackingId);
        // }

        let nextSection: FormSections;
        for (let i = 0; i < 10; i++) {
          stepperIndex++;
          nextSection = this.sortedList[stepperIndex];
          if (nextSection.Visible) {
            this.props.callback(this.props.programContainer);
            break;
          } else {
          }
        }
        this.setState(
          { validationErrMsg: [], stepperIndex: stepperIndex },
          () => {
            const firstHeader = document.querySelector("h1");
            window.scrollTo({ top: 0, behavior: "smooth" });
            // Check if an <h1> element was found and focus on it
            if (firstHeader) {
              firstHeader.focus();
            }
          },
        );
      }
    }
  };

  clearCurrentForm = () => {
    let currentSection = this.sortedList[this.state.stepperIndex];
    currentSection.ListOfFormSubSections.forEach((sub) => {
      sub.ListOfFormSectionElements.forEach((ele) => {
        // if (typeof ele.Value === 'object' && ele.Value !== null) {
        //     ele.Value = new AddressFieldSets();
        // } else {
        if (ele.Datatype !== "Label")
          //never clear lable as its purpose is for display
          ele.Value = "";
        if (ele.Datatype == "Address") {
          ele.Value = null;
          ele.Address = null;
        }

        if (
          ele.Datatype == "SelectWithRichText" ||
          ele.Datatype == "RadioButtonWithRichText"
        ) {
          ele.SelectionCode = "";
          ele.Value = "";
          // }
        }
      });
    });
    // gaEvent({
    //     action: 'click',
    //     category: 'ClearForm',
    //     label: this.props.isEng ? currentSection.ENUTitle : currentSection.FRATitle,
    // }, this.gaTrackingId);
  };

  EditableFieldsInForm = () => {
    let currentSection = this.sortedList[this.state.stepperIndex];
    let res = false;
    currentSection.ListOfFormSubSections.forEach((sub) => {
      sub.ListOfFormSectionElements.forEach((ele) => {
        if (
          ele.Editable == "Y" &&
          ele.Datatype != "Label" &&
          ele.Datatype != "HTML"
        ) {
          res = true;
        }
      });
    });

    return res;
  };

  addSubmitAndReview = () => {
    const currentSection = this.sortedList[this.state.stepperIndex];

    return (
      <div
        key={"addSubmitAndReview"}
        style={{
          marginTop: "0px",
          display: "flex",
          alignItems: "stretch",
          float: "right",
        }}
      >
        <div
          style={{
            display:
              this.state.showForm &&
              this.props.programContainer.displayForm !== "panel"
                ? "none"
                : "flex",
          }}
          className="ontario-padding-top-24-!"
        >
          <button
            className="ontario-button ontario-button--secondary"
            onClick={(e) => {
              this.setState({ showReview: false, showForm: true });
              window.scrollTo(0, 0);
              // gaPageview({title:this.props.isEng ? currentSection.ENUTitle : currentSection.FRATitle})
              // gaEvent({
              //     action: 'click',
              //     category: this.state.isComplete ? 'Back' : 'Edit',
              //     label: this.props.isEng ? currentSection.ENUTitle : currentSection.FRATitle
              // });
            }}
          >
            {this.state.isComplete
              ? this.props.isEng
                ? "Back"
                : "Écran précédent"
              : this.props.isEng
                ? "Edit"
                : "Modifier"}
          </button>

          <button
            className="ontario-button ontario-button--secondary"
            onClick={(e) => {
              if (this.props.isEng && this.props.programContainer.pdfTemplate) {
                generateAndDownloadPDF(this.props.programContainer, "en");
              } else if (
                !this.props.isEng &&
                this.props.programContainer.pdfTemplateFRA
              ) {
                generateAndDownloadPDF(this.props.programContainer, "fr");
              } else {
                if (this.props.programContainer.isHorizontalLayout) {
                  this.downloadPdfInHorizontal();
                } else {
                  this.downloadPDF2();
                }
              }
            }}
          >
            {this.props.isEng ? "Download PDF" : "Télécharger le PDF"}
          </button>

          <button
            className="ontario-button ontario-button--primary"
            style={{
              display: this.state.isComplete || false ? "none" : "block",
            }}
            onClick={(e) => {
              this.props.programContainer.EmailCopy
                ? this.sendAsEmail()
                : this.saveToServer(true);
            }}
          >
            {this.props.isEng ? "Submit" : "Envoyer"}
          </button>
        </div>
      </div>
    );
  };

  //Download pdf html2pdf version
  downloadPDF2 = async () => {
    const pdfJSX = () => {
      return (
        <div style={{ display: "block : none", margin: "25px 15px" }}>
          <style>
            {`
                            .pdf-two-column,
                            .pdf-row-column,
                            .pdf-two-column > div,
                            .pdf-row-column > div {
                                break-inside: avoid;
                                page-break-inside: avoid;
                            }
                        `}
          </style>
          {this.generateReviewHtmlString(true)}
        </div>
      );
    };
    const printElementRaw = ReactDOMServer.renderToString(pdfJSX());
    const printElement = printElementRaw
      .replace(
        /class="([^"]*\bpdf-two-column\b[^"]*)"/g,
        'class="pdf-row $1" style="page-break-inside: avoid; break-inside: avoid-page; display: table; table-layout: fixed; width: 100%;"',
      )
      .replace(
        /class="([^"]*\bpdf-row-column\b[^"]*)"/g,
        'class="pdf-row $1" style="page-break-inside: avoid; break-inside: avoid-page; display: table; table-layout: fixed; width: 100%;"',
      );
    const fileName = this.props.programContainer.CategoryId;
    const options = {
      margin: [20, 10, 20, 10],
      pagebreak: {
        mode: ["avoid-all", "css", "legacy"],
        avoid: [
          ".pdf-row",
          ".pdf-two-column",
          ".pdf-row-column",
          ".pdf-row-column>div",
          ".pdf-two-column>div",
        ],
      },
    };
    const pdf = await html2pdf()
      .set(options)
      .from(printElement)
      .toPdf()
      .get("pdf");
    this.addTimestampFooter(pdf);
    pdf.save(`${fileName}.pdf`);

    const pdfBytes = pdf.output("arraybuffer");
    const pdfBlob = new Blob([pdfBytes], { type: "application/pdf" });
    const url = URL.createObjectURL(pdfBlob);
    return url;
  };
  downloadPdfInHorizontal = async () => {
    // A function to clean up any previous line break hacks from the content
    const cleanString = (htmlString) => {
      return htmlString.replace("<br/>", "").replace("<br>", "").trim();
    };

    const pdfJSX = () => (
      <div
        style={{
          display: "block",
          width: "100%",
          margin: "0 auto",
          paddingTop: "0",
        }}
        id="pdf-content"
      >
        <style
          dangerouslySetInnerHTML={{
            __html: `
                * {
                    box-sizing: border-box;
                }
                
                /* 1. BASE TABLE STYLES */
                .pdf-section table {
                    width: 100%;
                    border-collapse: collapse; 
                    margin: 0;
                    table-layout: fixed;
                }

                /* 🔥 CRITICAL CHANGE: Negative margin to slightly overlap the separator line */
                .spaced-row {
                    margin-top: -1px; 
                }
                
                .pdf-section table,
                .pdf-section tr,
                .pdf-section td,
                .pdf-first-row,
                .pdf-first-row > div {
                    page-break-inside: auto !important;
                    break-inside: auto !important;
                }
                
                .pdf-section tr {
                    background-color: white; 
                }
                
                /* 2. Standard TD styles */
                .pdf-section td {
                    padding: 0.75rem 1rem;
                    vertical-align: top;
                    width: 50%;
                    white-space: pre-wrap;
                    word-wrap: break-word;
                    overflow-wrap: break-word;
                    word-break: normal;
                    hyphens: none;
                    /* CRITICAL CHANGE: Increased border thickness for visibility on subsequent rows */
                    border-bottom: #d5d5d5 solid .3rem; 
                }
                
                /* 3. DEFAULT ROWS: Use slightly larger padding for subsequent rows for content clearance */
                .pdf-section tr:not(:first-child) td {
                     padding-top: 0.75rem;   
                     padding-bottom: 0.75rem; 
                }
                
                /* 4. COLOR/SEPARATOR STYLES */
                .pdf-section td:first-child {
                    background-color: #F2F2F2;
                    font-weight: 600;
                    border-right: #d5d5d5 solid .18rem;
                }
                
                .pdf-section td:nth-child(2) {
                    text-align: left;
                    background-color: white;
                }
                
                /* 🔥 CRITICAL BLOCK FIX: Styling for the isolated DIV block (First Row) */
                .pdf-first-row {
                    display: flex; /* Use flexbox for stable two-column layout */
                    width: 100%;
                    margin-bottom: 0; 
                }
                
                .pdf-first-row > div {
                    padding: 0.75rem 1rem; 
                    line-height: 1.25;
                    word-wrap: break-word;
                    box-sizing: border-box;
                    min-height: 80px; 
                }

                .pdf-first-row > div:first-child {
                    width: 50%;
                    background: #F2F2F2;
                    font-weight: 600;
                    border-right: #d5d5d5 solid .18rem;
                    overflow: hidden; 
                }
                
                .pdf-first-row > div:nth-child(2) {
                    width: 50%;
                    background: white;
                    text-align: left;
                    white-space: pre-wrap;
                    word-wrap: break-word;
                    overflow-wrap: break-word;
                    word-break: normal;
                    hyphens: none;
                }
                
                /* 🔥 NEW CRITICAL FIX: Exaggerated style for the hard-coded separator line */
                .pdf-separator-line {
                    height: 3px; 
                    width: 100%;
                    background-color: #000000; /* Set to Black to guarantee visibility */
                }

                /* --- General Content Styles --- */
                .pdf-section td div {
                    display: block;
                    margin-bottom: 0.5rem;
                }
                
                .pdf-section td div:last-child {
                    margin-bottom: 0;
                }

                .oer-wrapper,
                .hero-shell,
                .hero-wrapper {
                    display: none !important;
                }
                
                .page-break {
                    page-break-before: always;
                    break-before: page;
                    height: 0;
                }
            `,
          }}
        />
        {this.generateReviewHtmlString(true)}
      </div>
    );

    const printElementRaw = ReactDOMServer.renderToString(pdfJSX());

    const parser = new DOMParser();
    const doc = parser.parseFromString(printElementRaw, "text/html");

    const twoColumnDivs = doc.querySelectorAll(
      ".pdf-two-column, .pdf-row-column",
    );

    let isFirstRow = true; // Tracker for the first element

    twoColumnDivs.forEach((div) => {
      const children = Array.from(div.children).filter(
        (child) => child.tagName === "DIV",
      );

      if (children.length >= 2) {
        if (isFirstRow) {
          // CRITICAL HACK: Convert the first row into a stable DIV/Flex structure
          const firstRowDiv = document.createElement("div");
          firstRowDiv.className = "pdf-first-row"; // Custom class for stable styles

          // Content left (Cleaned string)
          const contentLeft = document.createElement("div");
          contentLeft.innerHTML = cleanString(children[0].innerHTML);
          firstRowDiv.appendChild(contentLeft);

          // Content right (Cleaned string)
          const contentRight = document.createElement("div");
          contentRight.innerHTML = cleanString(children[1].innerHTML);
          firstRowDiv.appendChild(contentRight);

          // 🔥 CRITICAL FIX: Insert the separator DIV explicitly after the first row content
          const separatorDiv = document.createElement("div");
          separatorDiv.className = "pdf-separator-line";

          // Replace the original placeholder DIV with the first row DIV and the separator DIV
          div.parentNode.insertBefore(firstRowDiv, div);
          div.parentNode.insertBefore(separatorDiv, div);
          div.remove(); // Remove the original placeholder

          isFirstRow = false; // Mark that the first row is done
          return;
        }

        // For all subsequent rows, convert to a single-row table as before
        const table = document.createElement("table");
        table.className = div.className;

        // Apply 'spaced-row' class to all tables after the first one
        table.classList.add("spaced-row");

        const tbody = document.createElement("tbody");
        const tr = document.createElement("tr");

        const td1 = document.createElement("td");
        td1.innerHTML = children[0].innerHTML;
        if (children[0].className) td1.className = children[0].className;

        const td2 = document.createElement("td");
        td2.innerHTML = children[1].innerHTML;
        if (children[1].className) td2.className = children[1].className;

        tr.appendChild(td1);
        tr.appendChild(td2);
        tbody.appendChild(tr);
        table.appendChild(tbody);

        div.parentNode.replaceChild(table, div);
      }
    });

    const printElement = doc.body.innerHTML;

    const fileName = this.props.programContainer.CategoryId;

    const options = {
      margin: [20, 15, 20, 15],
      html2canvas: {
        scale: 6, // Max scale retained for highest resolution rendering
        useCORS: true,
      },
      jsPDF: {
        unit: "mm",
        format: "letter",
        orientation: "landscape",
      },
      pagebreak: { mode: ["css", "legacy"] },
    };

    const worker = html2pdf().set(options).from(printElement).toPdf();
    const pdf = await worker.get("pdf");

    this.addTimestampFooter(pdf);

    pdf.save(`${fileName}.pdf`);
  };

  render() {
    const programContainer = this.props.programContainer;
    if (programContainer == null) return null;
    if (this.state.showSessionEndPage) {
      return (
        <div
          style={{
            display: "block",
            maxWidth: "72rem",
            margin: "auto",
            padding: "0 1rem",
          }}
        >
          <SessionEndComponent
            isEng={this.props.isEng}
            programContainer={this.props.programContainer}
          />
        </div>
      );
    }

    if (this.state.showModal) {
      return (
        <div style={{ maxWidth: "72rem", margin: "auto", padding: "0 1rem" }}>
          <TimeoutComponent
            onClose={this.handleClose}
            onCancel={this.handleCancel}
            onTimeup={this.modalTimeout}
            isEng={this.props.isEng}
          />
          <div style={{ filter: "blur(2px)", pointerEvents: "none" }}>
            {this.generateHtmlString()}
          </div>
        </div>
      );
    }

    console.log(programContainer);
    const currentSection =
      programContainer.ListOfFormSections[this.state.stepperIndex];
    const hasLoginBanner =
      currentSection?.HasLoginBanner ?? currentSection?.LoginBanner;
    const displayLoginBanner = !programContainer.Profile && !!hasLoginBanner;
    const displayFeedbackBanner = currentSection?.FeedbackBanner;

    return (
      <>
        {displayFeedbackBanner && (
          <FeedbackBannerComponent
            isEng={this.props.isEng}
            programContainer={programContainer}
          />
        )}
        {displayLoginBanner && (
          <LoginBannerComponent
            isEng={this.props.isEng}
            HasLoginBanner={hasLoginBanner}
            wording={currentSection?.LoginBannerWording}
            wordingFRA={currentSection?.LoginBannerWordingFRA}
          />
        )}
        <div style={{ maxWidth: "72rem", margin: "auto", padding: "0 1rem" }}>
          {this.generateHtmlString()}
          {this.state.showPrintDialog && (
            <PDFViewerPrintComponent
              fileUrl={this.state.pdfFileUrl}
              isEng={this.props.isEng}
              visible={this.state.showPrintDialog}
              onClose={() => this.setState({ showPrintDialog: false })}
            />
          )}
        </div>
      </>
    );
  }

  generateHtmlString = () => {
    if (this.props.programContainer.CategoryId?.toUpperCase() == "CMA") {
      return (
        <div className="ontario-row">
          <CMAFormComponent
            programContainer={this.props.programContainer}
            isEng={this.props.isEng}
            callback={(p) => this.props.callback(p)}
            callbackValidate={(errors) => {
              this.setState({ validationErrMsg: errors }, () => {
                this.props.callback(this.props.programContainer);
                window.scrollTo({ top: 0, behavior: "smooth" });
              });
            }}
          />
        </div>
      );
    }
    const topButton = this.renderTopButton();
    const isCustomReviewActive = this.isCustomizedReviewPageActive();
    const showReviewPanel = this.state.showReview || isCustomReviewActive;

    let currentSectionForReview: FormSections | undefined;
    if (showReviewPanel) {
      const sections =
        this.sortedList ||
        this.props.programContainer?.ListOfFormSections ||
        [];
      const customizedReviewSections = sections.filter(
        (s) => s.CustomizedReviewPage && s.Visible,
      );

      if (customizedReviewSections.length > 1) {
        const currentStepperSection =
          sections[this.getSafeStepperIndex(this.state.stepperIndex)];
        const currentReviewIndex = customizedReviewSections.indexOf(
          currentStepperSection,
        );

        if (currentReviewIndex >= 0) {
          currentSectionForReview =
            customizedReviewSections[currentReviewIndex];
        } else {
          currentSectionForReview = customizedReviewSections[0];
        }
      } else if (isCustomReviewActive) {
        currentSectionForReview =
          sections[this.getSafeStepperIndex(this.state.stepperIndex)];
      }
    }
    switch (this.props.programContainer.displayForm) {
      case "panel":
        return (
          <>
            <div style={{ display: this.state.showForm ? "block" : "none" }}>
              {this.previewForm()}
              {this.renderConfirmationDialog()}
              {this.addSubmitAndReview()}
            </div>
            {topButton}
            <div
              style={{
                display: showReviewPanel ? "block" : "none",
                marginTop: "5%",
              }}
            >
              {this.generateReviewHtmlString(
                false,
                isCustomReviewActive,
                currentSectionForReview,
              )}
            </div>
          </>
        );
      case "hiddenStepper":
        return (
          <>
            <div className="ontario-row">
              <div>
                <Toast ref={(el) => (this.growl = el)} />
              </div>
              <div style={{ display: this.state.showForm ? "block" : "none" }}>
                {this.previewFormInStepper()}
                <div
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                    width: "100%",
                  }}
                >
                  {!this.props.programContainer.TopNavigation &&
                    this.continueBtn()}
                </div>
              </div>
              {topButton}
              <div style={{ display: showReviewPanel ? "block" : "none" }}>
                {this.generateReviewHtmlString(
                  false,
                  isCustomReviewActive,
                  currentSectionForReview,
                )}
              </div>
            </div>
          </>
        );
      case "stepper":
      case "NoIndicatorStepper":
      case "hiddenStepperWithSectionTitle":
        return (
          <>
            <div>
              {/* @ts-ignore */}
              <Toast ref={(el) => (this.growl = el)} />
            </div>
            <div style={{ display: this.state.showForm ? "block" : "none" }}>
              {this.previewFormInStepper()}
              {this.renderConfirmationDialog()}
              <div
                style={{
                  display: this.continueButtonHidden ? "block" : "none",
                }}
              >
                {this.addSubmitAndReview()}
              </div>
              <br />
              {this.stepperBtn()}
            </div>
            {topButton}
            <div
              style={{
                display: showReviewPanel ? "block" : "none",
                marginTop: "5%",
              }}
            >
              {this.generateReviewHtmlString(
                false,
                isCustomReviewActive,
                currentSectionForReview,
              )}
            </div>
          </>
        );
      case "progressBarStepper":
        return (
          <>
            <div>
              {/* @ts-ignore */}
              <Toast ref={(el) => (this.growl = el)} />
            </div>
            <div style={{ display: this.state.showForm ? "block" : "none" }}>
              {this.previewFormInStepper()}
              {this.renderConfirmationDialog()}
              <div
                style={{
                  display: this.continueButtonHidden ? "block" : "none",
                }}
              >
                {this.addSubmitAndReview()}
              </div>
              {this.stepperBtn()}
            </div>
            {topButton}
          </>
        );
        break;

      default:
        return (
          <>
            {this.previewForm()}
            {topButton}
          </>
        );
    }
  };

  handleRemoveConfirmation = (accept: boolean) => {
    if (accept) {
      this.sectionArray.splice(this.removingIndex, 1);
    }

    this.setState({ showConfirmationDialog: false });
  };

  renderConfirmationDialog = () => {
    const showConfirmationDialog = this.state.showConfirmationDialog;
    return (
      <>
        {/* @ts-ignore */}
        <ConfirmDialog
          visible={showConfirmationDialog}
          onHide={() => this.handleRemoveConfirmation(false)}
          message="Are you sure you want to remove this?"
          header="Confirmation"
          icon="pi pi-exclamation-triangle"
          accept={() => this.handleRemoveConfirmation(true)}
          reject={() => this.setState({ showConfirmationDialog: false })}
          closable={false}
        />
      </>
    );
  };

  generateReviewHtmlString = (
    forDownload: boolean = false,
    forceShow: boolean = false,
    currentCustomizedReviewSection?: FormSections,
  ) => {
    return generateReviewHtml({
      programContainer: this.props.programContainer,
      isEng: this.props.isEng,
      forDownload,
      forceShow,
      currentCustomizedReviewSection,
      showReview: this.state.showReview,
      isBXP: this.isBXP,
      showPrintDialog: this.state.showPrintDialog,
      isBXPSubmit: this.state.isBXPSubmit,
      htmlToReactParserInstance: new this.HtmlToReactParser(),
      activeStepList: this.activeStepList,
      addUrlToHistory: (index) => this.addUrlToHistory(index),
      setStatus: (index) => this.setStatus(index),
      callback: (programContainer) => this.props.callback(programContainer),
      renderStepperHeader: () => this.stepperHeaderGeneration(),
      renderSubmitAndReview: () => this.addSubmitAndReview(),
      handleLoginToSaveDraft: this.handleLoginToSaveDraft,
      handleSaveAndContinueLater: this.handleSaveAndContinueLater,
      isBusy: this.state.isBusy,
      confirmationVisible: this.state.confirmationVisible,
      summaryVisible: this.state.summaryVisible,
      transactionId: this.state.transactionId,
      submissionError: this.state.submissionError,
      showDownloadSummary: this.state.showDownloadSummary,
      applicationType: this.state.applicationType,
      renewType: this.state.renewType,
      parentRef: this,
      setStateProp: (
        confirmationVisible,
        summaryVisible,
        transactionId,
        submissionError,
        showDownloadSummary,
        applicationType,
        renewType,
      ) => {
        this.setState({
          confirmationVisible,
          summaryVisible,
          transactionId,
          submissionError,
          showDownloadSummary,
          applicationType,
          renewType,
        });
      },
    });
  };

  saveToServer = async (isSubmit) => {
    this.setState({ isBusy: true });
    try {
      if (
        this.props.programContainer.SubmitPreScript &&
        this.props.programContainer.SubmitPreScript?.trim().length > 0
      ) {
        const customJSFunc = eval(
          `(${this.props.programContainer.SubmitPreScript})`,
        );
        try {
          customJSFunc(isSubmit);
        } catch (ex) {
          console.log(ex);
        }
      }
      let htmlStr = null;
      if (isSubmit && this.props.programContainer.AuthRequired === "tk") {
        htmlStr = this.generateReviewHtmlString(true);
      }

      let ret = await DataUtils.saveToServer(
        isSubmit,
        this.props.programContainer,
        this.props.isEng,
        htmlStr,
        this.growl,
        this.props.callback,
      );

      if (
        ret &&
        this.props.programContainer.SubmitPostScript &&
        this.props.programContainer.SubmitPostScript?.trim().length > 0
      ) {
        const customJSFunc = eval(
          `(${this.props.programContainer.SubmitPostScript})`,
        );
        try {
          customJSFunc(isSubmit);
        } catch (ex) {
          console.log(ex);
        }
      }
      if (ret && isSubmit && this.props.programContainer.ClearFormAfterSubmit) {
        DataUtils.clearFormValue(this.props.programContainer);
        SectionUtils.resetDirtyFlags(this.props.programContainer);
      }
      this.setState({ isBusy: false });
      this.props.callback(this.props.programContainer);
    } catch (ex) {
      this.setState({ isBusy: false });
    }
  };

  saveToBXPServer = async (
    isSubmit: boolean,
    html: string[],
  ): Promise<boolean> => {
    this.setState({ isBusy: true, isBXPSubmit: isSubmit }); // Track submission state properly
    try {
      // Execute pre-submit script if defined
      if (
        this.props.programContainer.SubmitPreScript &&
        this.props.programContainer.SubmitPreScript.trim().length > 0
      ) {
        const customJSFunc = eval(
          `(${this.props.programContainer.SubmitPreScript})`,
        );
        try {
          customJSFunc(isSubmit);
        } catch (ex) {
          console.error("Error in SubmitPreScript:", ex);
        }
      }

      // Save to server
      const ret = await DataUtils.saveToServer(
        isSubmit,
        this.props.programContainer,
        this.props.isEng,
        html,
        this.growl,
        this.props.callback,
      );

      // Execute post-submit script if defined
      if (
        ret &&
        this.props.programContainer.SubmitPostScript &&
        this.props.programContainer.SubmitPostScript.trim().length > 0
      ) {
        const customJSFunc = eval(
          `(${this.props.programContainer.SubmitPostScript})`,
        );
        try {
          customJSFunc(isSubmit);
        } catch (ex) {
          console.error("Error in SubmitPostScript:", ex);
        }
      }
      if (ret && isSubmit && this.props.programContainer.ClearFormAfterSubmit) {
        DataUtils.clearFormValue(this.props.programContainer);
        SectionUtils.resetDirtyFlags(this.props.programContainer);
      }

      // Reset busy state and update program container
      this.setState({ isBusy: false, isBXPSubmit: false });
      this.props.callback(this.props.programContainer);
      return ret;
    } catch (ex) {
      console.error("Error during saveToServer:", ex);
      this.setState({ isBusy: false, isBXPSubmit: false });
      return false;
    }
  };

  // option for eComplaint (not in use; moved to CustomizedSummary > HandleSubmit)
  sendAsEmail = async () => {
    this.setState({ isBusy: true });
    console.log("send as email");

    // note: hardcoded for eComplaint form -- change property name (lisAttachments) to binding name of attachment field
    const payload = DataUtils.collectFormValue(this.props.programContainer);
    const listOfAttachments = payload.lisAttachments;
    let base64Attachments = null;
    let attachmentPaths = null;
    if (listOfAttachments) {
      base64Attachments = listOfAttachments.map((item) => item.attachment);
      //console.log(base64Attachments);
      attachmentPaths = listOfAttachments.map((item) => item.path);
    }

    const emailRequest = {
      from: this.props.programContainer.EmailSender,
      multipleTo: this.props.programContainer.EmailRecipients,
      subject: this.props.programContainer.EmailSubject,
      content: this.props.programContainer.EmailBody,
      pdf: await generateBase64PdfTemplate(
        this.props.programContainer,
        this.props.isEng ? "en" : "fr",
      ),
      xml: DetailFormComponent.generateXML(payload),
      attachments: base64Attachments,
      attachmentNames: attachmentPaths,
    };

    try {
      let api = URLUtils.concatUrls("data/email/send-email");
      const token = SessionStorageService.getAccessToken(TOKEN_TYPE.API);
      let headers = {};
      if (!token) {
        headers = {
          Authorization: `Bearer ${token}`,
        };
      } else {
        headers = {
          referrerPolicy: "no-referrer",
        };
      }

      const response = await axios.post(api, emailRequest, {
        headers: headers,
      });

      console.log("Request was sent successfully.", response.data.message);
      if (this.props.programContainer.ClearFormAfterSubmit) {
        DataUtils.clearFormValue(this.props.programContainer);
        SectionUtils.resetDirtyFlags(this.props.programContainer);
        this.props.callback(this.props.programContainer);
      }
    } catch (error) {
      console.error(
        "Error encountered.",
        error.response?.data?.message || error.message,
      );
      this.setState({ isBusy: false });
    }
  };
  handleBXPSummaryCallback = (programContainer, stepperIndex) => {
    // this.setState({ showReview: false, showForm: true });
    this.setState(
      {
        validationErrMsg: [],
        showReview: false,
        showForm: true,
        stepperIndex: stepperIndex,
      },
      () => {
        // Scroll to the top of the page
        window.scrollTo({ top: 0, behavior: "smooth" });

        // Update the URL history to reflect the first section
        this.addUrlToHistory(stepperIndex);

        // Callback to update the program container
        this.props.callback(this.props.programContainer);
      },
    );
  };
}
